import x, { useRef as I, useCallback as N, useState as G, useContext as W, useEffect as K, createContext as Z, useMemo as te, forwardRef as ge } from "react";
import kn, { flushSync as Bt } from "react-dom";
function Ut(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number") r += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var o = e.length;
    for (t = 0; t < o; t++) e[t] && (n = Ut(e[t])) && (r && (r += " "), r += n);
  } else for (n in e) e[n] && (r && (r += " "), r += n);
  return r;
}
function Hn() {
  for (var e, t, n = 0, r = "", o = arguments.length; n < o; n++) (e = arguments[n]) && (t = Ut(e)) && (r && (r += " "), r += t);
  return r;
}
const q = typeof document < "u" ? x.useLayoutEffect : () => {
};
function oe(e) {
  const t = I(null);
  return q(() => {
    t.current = e;
  }, [
    e
  ]), N((...n) => {
    const r = t.current;
    return r?.(...n);
  }, []);
}
const ke = {
  prefix: String(Math.round(Math.random() * 1e10)),
  current: 0
}, Wt = /* @__PURE__ */ x.createContext(ke), An = /* @__PURE__ */ x.createContext(!1);
let Nn = !!(typeof window < "u" && window.document && window.document.createElement), Ue = /* @__PURE__ */ new WeakMap();
function Rn(e = !1) {
  let t = W(Wt), n = I(null);
  if (n.current === null && !e) {
    var r, o;
    let i = (o = x.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || o === void 0 || (r = o.ReactCurrentOwner) === null || r === void 0 ? void 0 : r.current;
    if (i) {
      let a = Ue.get(i);
      a == null ? Ue.set(i, {
        id: t.current,
        state: i.memoizedState
      }) : i.memoizedState !== a.state && (t.current = a.id, Ue.delete(i));
    }
    n.current = ++t.current;
  }
  return n.current;
}
function Kn(e) {
  let t = W(Wt);
  t === ke && !Nn && process.env.NODE_ENV !== "production" && console.warn("When server rendering, you must wrap your application in an <SSRProvider> to ensure consistent ids are generated between the client and server.");
  let n = Rn(!!e), r = t === ke && process.env.NODE_ENV === "test" ? "react-aria" : `react-aria${t.prefix}`;
  return e || `${r}-${n}`;
}
function _n(e) {
  let t = x.useId(), [n] = G(at()), r = n || process.env.NODE_ENV === "test" ? "react-aria" : `react-aria${ke.prefix}`;
  return e || `${r}-${t}`;
}
const Vn = typeof x.useId == "function" ? _n : Kn;
function zn() {
  return !1;
}
function Bn() {
  return !0;
}
function Un(e) {
  return () => {
  };
}
function at() {
  return typeof x.useSyncExternalStore == "function" ? x.useSyncExternalStore(Un, zn, Bn) : W(An);
}
let Wn = !!(typeof window < "u" && window.document && window.document.createElement), fe = /* @__PURE__ */ new Map(), ye;
typeof FinalizationRegistry < "u" && (ye = new FinalizationRegistry((e) => {
  fe.delete(e);
}));
function be(e) {
  let [t, n] = G(e), r = I(null), o = Vn(t), i = I(null);
  if (ye && ye.register(i, o), Wn) {
    const a = fe.get(o);
    a && !a.includes(r) ? a.push(r) : fe.set(o, [
      r
    ]);
  }
  return q(() => {
    let a = o;
    return () => {
      ye && ye.unregister(i), fe.delete(a);
    };
  }, [
    o
  ]), K(() => {
    let a = r.current;
    return a && n(a), () => {
      a && (r.current = null);
    };
  }), o;
}
function jn(e, t) {
  if (e === t) return e;
  let n = fe.get(e);
  if (n)
    return n.forEach((o) => o.current = t), t;
  let r = fe.get(t);
  return r ? (r.forEach((o) => o.current = e), e) : t;
}
function st(...e) {
  return (...t) => {
    for (let n of e) typeof n == "function" && n(...t);
  };
}
const z = (e) => {
  var t;
  return (t = e?.ownerDocument) !== null && t !== void 0 ? t : document;
}, X = (e) => e && "window" in e && e.window === e ? e : z(e).defaultView || window;
function Gn(e) {
  return e !== null && typeof e == "object" && "nodeType" in e && typeof e.nodeType == "number";
}
function Yn(e) {
  return Gn(e) && e.nodeType === Node.DOCUMENT_FRAGMENT_NODE && "host" in e;
}
let Xn = !1;
function ct() {
  return Xn;
}
function k(e, t) {
  if (!ct()) return t && e ? e.contains(t) : !1;
  if (!e || !t) return !1;
  let n = t;
  for (; n !== null; ) {
    if (n === e) return !0;
    n.tagName === "SLOT" && n.assignedSlot ? n = n.assignedSlot.parentNode : Yn(n) ? n = n.host : n = n.parentNode;
  }
  return !1;
}
const Te = (e = document) => {
  var t;
  if (!ct()) return e.activeElement;
  let n = e.activeElement;
  for (; n && "shadowRoot" in n && (!((t = n.shadowRoot) === null || t === void 0) && t.activeElement); ) n = n.shadowRoot.activeElement;
  return n;
};
function D(e) {
  return ct() && e.target.shadowRoot && e.composedPath ? e.composedPath()[0] : e.target;
}
function _(...e) {
  let t = {
    ...e[0]
  };
  for (let n = 1; n < e.length; n++) {
    let r = e[n];
    for (let o in r) {
      let i = t[o], a = r[o];
      typeof i == "function" && typeof a == "function" && // This is a lot faster than a regex.
      o[0] === "o" && o[1] === "n" && o.charCodeAt(2) >= /* 'A' */
      65 && o.charCodeAt(2) <= /* 'Z' */
      90 ? t[o] = st(i, a) : (o === "className" || o === "UNSAFE_className") && typeof i == "string" && typeof a == "string" ? t[o] = Hn(i, a) : o === "id" && i && a ? t.id = jn(i, a) : t[o] = a !== void 0 ? a : i;
    }
  }
  return t;
}
function jt(...e) {
  return e.length === 1 && e[0] ? e[0] : (t) => {
    let n = !1;
    const r = e.map((o) => {
      const i = yt(o, t);
      return n || (n = typeof i == "function"), i;
    });
    if (n) return () => {
      r.forEach((o, i) => {
        typeof o == "function" ? o() : yt(e[i], null);
      });
    };
  };
}
function yt(e, t) {
  if (typeof e == "function") return e(t);
  e != null && (e.current = t);
}
const Zn = /* @__PURE__ */ new Set([
  "id"
]), qn = /* @__PURE__ */ new Set([
  "aria-label",
  "aria-labelledby",
  "aria-describedby",
  "aria-details"
]), Jn = /* @__PURE__ */ new Set([
  "href",
  "hrefLang",
  "target",
  "rel",
  "download",
  "ping",
  "referrerPolicy"
]), Qn = /^(data-.*)$/;
function xe(e, t = {}) {
  let { labelable: n, isLink: r, propNames: o } = t, i = {};
  for (const a in e) Object.prototype.hasOwnProperty.call(e, a) && (Zn.has(a) || n && qn.has(a) || r && Jn.has(a) || o?.has(a) || Qn.test(a)) && (i[a] = e[a]);
  return i;
}
function ve(e) {
  if (er()) e.focus({
    preventScroll: !0
  });
  else {
    let t = tr(e);
    e.focus(), nr(t);
  }
}
let Fe = null;
function er() {
  if (Fe == null) {
    Fe = !1;
    try {
      document.createElement("div").focus({
        get preventScroll() {
          return Fe = !0, !0;
        }
      });
    } catch {
    }
  }
  return Fe;
}
function tr(e) {
  let t = e.parentNode, n = [], r = document.scrollingElement || document.documentElement;
  for (; t instanceof HTMLElement && t !== r; )
    (t.offsetHeight < t.scrollHeight || t.offsetWidth < t.scrollWidth) && n.push({
      element: t,
      scrollTop: t.scrollTop,
      scrollLeft: t.scrollLeft
    }), t = t.parentNode;
  return r instanceof HTMLElement && n.push({
    element: r,
    scrollTop: r.scrollTop,
    scrollLeft: r.scrollLeft
  }), n;
}
function nr(e) {
  for (let { element: t, scrollTop: n, scrollLeft: r } of e)
    t.scrollTop = n, t.scrollLeft = r;
}
function _e(e) {
  var t;
  return typeof window > "u" || window.navigator == null ? !1 : ((t = window.navigator.userAgentData) === null || t === void 0 ? void 0 : t.brands.some((n) => e.test(n.brand))) || e.test(window.navigator.userAgent);
}
function ut(e) {
  var t;
  return typeof window < "u" && window.navigator != null ? e.test(((t = window.navigator.userAgentData) === null || t === void 0 ? void 0 : t.platform) || window.navigator.platform) : !1;
}
function ne(e) {
  if (process.env.NODE_ENV === "test") return e;
  let t = null;
  return () => (t == null && (t = e()), t);
}
const $e = ne(function() {
  return ut(/^Mac/i);
}), rr = ne(function() {
  return ut(/^iPhone/i);
}), Gt = ne(function() {
  return ut(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  $e() && navigator.maxTouchPoints > 1;
}), dt = ne(function() {
  return rr() || Gt();
});
ne(function() {
  return $e() || dt();
});
const Yt = ne(function() {
  return _e(/AppleWebKit/i) && !or();
}), or = ne(function() {
  return _e(/Chrome/i);
}), Xt = ne(function() {
  return _e(/Android/i);
}), ir = ne(function() {
  return _e(/Firefox/i);
}), Zt = /* @__PURE__ */ Z({
  isNative: !0,
  open: lr,
  useHref: (e) => e
});
function Bo(e) {
  let { children: t, navigate: n, useHref: r } = e, o = te(() => ({
    isNative: !1,
    open: (i, a, l, u) => {
      Qt(i, (d) => {
        Jt(d, a) ? n(l, u) : ce(d, a);
      });
    },
    useHref: r || ((i) => i)
  }), [
    n,
    r
  ]);
  return /* @__PURE__ */ x.createElement(Zt.Provider, {
    value: o
  }, t);
}
function qt() {
  return W(Zt);
}
function Jt(e, t) {
  let n = e.getAttribute("target");
  return (!n || n === "_self") && e.origin === location.origin && !e.hasAttribute("download") && !t.metaKey && // open in new tab (mac)
  !t.ctrlKey && // open in new tab (windows)
  !t.altKey && // download
  !t.shiftKey;
}
function ce(e, t, n = !0) {
  var r, o;
  let { metaKey: i, ctrlKey: a, altKey: l, shiftKey: u } = t;
  ir() && (!((o = window.event) === null || o === void 0 || (r = o.type) === null || r === void 0) && r.startsWith("key")) && e.target === "_blank" && ($e() ? i = !0 : a = !0);
  let d = Yt() && $e() && !Gt() && process.env.NODE_ENV !== "test" ? new KeyboardEvent("keydown", {
    keyIdentifier: "Enter",
    metaKey: i,
    ctrlKey: a,
    altKey: l,
    shiftKey: u
  }) : new MouseEvent("click", {
    metaKey: i,
    ctrlKey: a,
    altKey: l,
    shiftKey: u,
    bubbles: !0,
    cancelable: !0
  });
  ce.isOpening = n, ve(e), e.dispatchEvent(d), ce.isOpening = !1;
}
ce.isOpening = !1;
function Qt(e, t) {
  if (e instanceof HTMLAnchorElement) t(e);
  else if (e.hasAttribute("data-href")) {
    let n = document.createElement("a");
    n.href = e.getAttribute("data-href"), e.hasAttribute("data-target") && (n.target = e.getAttribute("data-target")), e.hasAttribute("data-rel") && (n.rel = e.getAttribute("data-rel")), e.hasAttribute("data-download") && (n.download = e.getAttribute("data-download")), e.hasAttribute("data-ping") && (n.ping = e.getAttribute("data-ping")), e.hasAttribute("data-referrer-policy") && (n.referrerPolicy = e.getAttribute("data-referrer-policy")), e.appendChild(n), t(n), e.removeChild(n);
  }
}
function lr(e, t) {
  Qt(e, (n) => ce(n, t));
}
function ar(e) {
  let t = qt();
  var n;
  const r = t.useHref((n = e?.href) !== null && n !== void 0 ? n : "");
  return {
    href: e?.href ? r : void 0,
    target: e?.target,
    rel: e?.rel,
    download: e?.download,
    ping: e?.ping,
    referrerPolicy: e?.referrerPolicy
  };
}
let ie = /* @__PURE__ */ new Map(), Ze = /* @__PURE__ */ new Set();
function Pt() {
  if (typeof window > "u") return;
  function e(r) {
    return "propertyName" in r;
  }
  let t = (r) => {
    if (!e(r) || !r.target) return;
    let o = ie.get(r.target);
    o || (o = /* @__PURE__ */ new Set(), ie.set(r.target, o), r.target.addEventListener("transitioncancel", n, {
      once: !0
    })), o.add(r.propertyName);
  }, n = (r) => {
    if (!e(r) || !r.target) return;
    let o = ie.get(r.target);
    if (o && (o.delete(r.propertyName), o.size === 0 && (r.target.removeEventListener("transitioncancel", n), ie.delete(r.target)), ie.size === 0)) {
      for (let i of Ze) i();
      Ze.clear();
    }
  };
  document.body.addEventListener("transitionrun", t), document.body.addEventListener("transitionend", n);
}
typeof document < "u" && (document.readyState !== "loading" ? Pt() : document.addEventListener("DOMContentLoaded", Pt));
function sr() {
  for (const [e] of ie)
    "isConnected" in e && !e.isConnected && ie.delete(e);
}
function en(e) {
  requestAnimationFrame(() => {
    sr(), ie.size === 0 ? e() : Ze.add(e);
  });
}
function ft() {
  let e = I(/* @__PURE__ */ new Map()), t = N((o, i, a, l) => {
    let u = l?.once ? (...d) => {
      e.current.delete(a), a(...d);
    } : a;
    e.current.set(a, {
      type: i,
      eventTarget: o,
      fn: u,
      options: l
    }), o.addEventListener(i, u, l);
  }, []), n = N((o, i, a, l) => {
    var u;
    let d = ((u = e.current.get(a)) === null || u === void 0 ? void 0 : u.fn) || a;
    o.removeEventListener(i, d, l), e.current.delete(a);
  }, []), r = N(() => {
    e.current.forEach((o, i) => {
      n(o.eventTarget, o.type, i, o.options);
    });
  }, [
    n
  ]);
  return K(() => r, [
    r
  ]), {
    addGlobalListener: t,
    removeGlobalListener: n,
    removeAllGlobalListeners: r
  };
}
function cr(e, t) {
  let { id: n, "aria-label": r, "aria-labelledby": o } = e;
  return n = be(n), o && r ? o = [
    .../* @__PURE__ */ new Set([
      n,
      ...o.trim().split(/\s+/)
    ])
  ].join(" ") : o && (o = o.trim().split(/\s+/).join(" ")), !r && !o && t && (r = t), {
    id: n,
    "aria-label": r,
    "aria-labelledby": o
  };
}
function pt(e) {
  const t = I(null), n = I(void 0), r = N((o) => {
    if (typeof e == "function") {
      const i = e, a = i(o);
      return () => {
        typeof a == "function" ? a() : i(null);
      };
    } else if (e)
      return e.current = o, () => {
        e.current = null;
      };
  }, [
    e
  ]);
  return te(() => ({
    get current() {
      return t.current;
    },
    set current(o) {
      t.current = o, n.current && (n.current(), n.current = void 0), o != null && (n.current = r(o));
    }
  }), [
    r
  ]);
}
function ur() {
  return typeof window.ResizeObserver < "u";
}
function Et(e) {
  const { ref: t, box: n, onResize: r } = e;
  K(() => {
    let o = t?.current;
    if (o)
      if (ur()) {
        const i = new window.ResizeObserver((a) => {
          a.length && r();
        });
        return i.observe(o, {
          box: n
        }), () => {
          o && i.unobserve(o);
        };
      } else
        return window.addEventListener("resize", r, !1), () => {
          window.removeEventListener("resize", r, !1);
        };
  }, [
    r,
    t,
    n
  ]);
}
function tn(e, t) {
  q(() => {
    if (e && e.ref && t)
      return e.ref.current = t.current, () => {
        e.ref && (e.ref.current = null);
      };
  });
}
function qe(e) {
  return e.mozInputSource === 0 && e.isTrusted ? !0 : Xt() && e.pointerType ? e.type === "click" && e.buttons === 1 : e.detail === 0 && !e.pointerType;
}
function dr(e) {
  return !Xt() && e.width === 0 && e.height === 0 || e.width === 1 && e.height === 1 && e.pressure === 0 && e.detail === 0 && e.pointerType === "mouse";
}
function fr(e, t = !0) {
  let [n, r] = G(!0), o = n && t;
  return q(() => {
    if (o && e.current && "getAnimations" in e.current)
      for (let i of e.current.getAnimations()) i instanceof CSSTransition && i.cancel();
  }, [
    e,
    o
  ]), nn(e, o, N(() => r(!1), [])), o;
}
function pr(e, t) {
  let [n, r] = G(t ? "open" : "closed");
  switch (n) {
    case "open":
      t || r("exiting");
      break;
    case "closed":
    case "exiting":
      t && r("open");
      break;
  }
  let o = n === "exiting";
  return nn(e, o, N(() => {
    r((i) => i === "exiting" ? "closed" : i);
  }, [])), o;
}
function nn(e, t, n) {
  q(() => {
    if (t && e.current) {
      if (!("getAnimations" in e.current)) {
        n();
        return;
      }
      let r = e.current.getAnimations();
      if (r.length === 0) {
        n();
        return;
      }
      let o = !1;
      return Promise.all(r.map((i) => i.finished)).then(() => {
        o || Bt(() => {
          n();
        });
      }).catch(() => {
      }), () => {
        o = !0;
      };
    }
  }, [
    e,
    t,
    n
  ]);
}
const rn = [
  "input:not([disabled]):not([type=hidden])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  "button:not([disabled])",
  "a[href]",
  "area[href]",
  "summary",
  "iframe",
  "object",
  "embed",
  "audio[controls]",
  "video[controls]",
  '[contenteditable]:not([contenteditable^="false"])'
], br = rn.join(":not([hidden]),") + ",[tabindex]:not([disabled]):not([hidden])";
rn.push('[tabindex]:not([tabindex="-1"]):not([disabled])');
function on(e) {
  return e.matches(br);
}
function ln(e, t, n) {
  let [r, o] = G(e || t), i = I(e !== void 0), a = e !== void 0;
  K(() => {
    let d = i.current;
    d !== a && process.env.NODE_ENV !== "production" && console.warn(`WARN: A component changed from ${d ? "controlled" : "uncontrolled"} to ${a ? "controlled" : "uncontrolled"}.`), i.current = a;
  }, [
    a
  ]);
  let l = a ? e : r, u = N((d, ...f) => {
    let p = (g, ...v) => {
      n && (Object.is(l, g) || n(g, ...v)), a || (l = g);
    };
    typeof d == "function" ? (process.env.NODE_ENV !== "production" && console.warn("We can not support a function callback. See Github Issues for details https://github.com/adobe/react-spectrum/issues/2320"), o((v, ...m) => {
      let $ = d(a ? l : v, ...m);
      return p($, ...f), a ? v : $;
    })) : (a || o(d), p(d, ...f));
  }, [
    a,
    l,
    n
  ]);
  return [
    l,
    u
  ];
}
function we(e, t = -1 / 0, n = 1 / 0) {
  return Math.min(Math.max(e, t), n);
}
const vr = Symbol("default");
function $r({ values: e, children: t }) {
  for (let [n, r] of e)
    t = /* @__PURE__ */ x.createElement(n.Provider, {
      value: r
    }, t);
  return t;
}
function Se(e) {
  let { className: t, style: n, children: r, defaultClassName: o, defaultChildren: i, defaultStyle: a, values: l } = e;
  return te(() => {
    let u, d, f;
    return typeof t == "function" ? u = t({
      ...l,
      defaultClassName: o
    }) : u = t, typeof n == "function" ? d = n({
      ...l,
      defaultStyle: a || {}
    }) : d = n, typeof r == "function" ? f = r({
      ...l,
      defaultChildren: i
    }) : r == null ? f = i : f = r, {
      className: u ?? o,
      style: d || a ? {
        ...a,
        ...d
      } : void 0,
      children: f ?? i,
      "data-rac": ""
    };
  }, [
    t,
    n,
    r,
    o,
    i,
    a,
    l
  ]);
}
function gr(e, t) {
  let n = W(e);
  if (t === null)
    return null;
  if (n && typeof n == "object" && "slots" in n && n.slots) {
    let r = t || vr;
    if (!n.slots[r]) {
      let o = new Intl.ListFormat().format(Object.keys(n.slots).map((a) => `"${a}"`)), i = t ? `Invalid slot "${t}".` : "A slot prop is required.";
      throw new Error(`${i} Valid slot names are ${o}.`);
    }
    return n.slots[r];
  }
  return n;
}
function Le(e, t, n) {
  let r = gr(n, e.slot) || {}, { ref: o, ...i } = r, a = pt(te(() => jt(t, o), [
    t,
    o
  ])), l = _(i, e);
  return "style" in i && i.style && "style" in e && e.style && (typeof i.style == "function" || typeof e.style == "function" ? l.style = (u) => {
    let d = typeof i.style == "function" ? i.style(u) : i.style, f = {
      ...u.defaultStyle,
      ...d
    }, p = typeof e.style == "function" ? e.style({
      ...u,
      defaultStyle: f
    }) : e.style;
    return {
      ...f,
      ...p
    };
  } : l.style = {
    ...i.style,
    ...e.style
  }), [
    l,
    a
  ];
}
function mr(e = !0) {
  let [t, n] = G(e), r = I(!1), o = N((i) => {
    r.current = !0, n(!!i);
  }, []);
  return q(() => {
    r.current || n(!1);
  }, []), [
    o,
    t
  ];
}
if (typeof HTMLTemplateElement < "u") {
  const e = Object.getOwnPropertyDescriptor(Node.prototype, "firstChild").get;
  Object.defineProperty(HTMLTemplateElement.prototype, "firstChild", {
    configurable: !0,
    enumerable: !0,
    get: function() {
      return this.dataset.reactAriaHidden ? this.content.firstChild : e.call(this);
    }
  });
}
const hr = /* @__PURE__ */ Z(!1);
function yr(e) {
  let t = (n, r) => W(hr) ? null : e(n, r);
  return t.displayName = e.displayName || e.name, ge(t);
}
function bt(e) {
  let t = e;
  return t.nativeEvent = e, t.isDefaultPrevented = () => t.defaultPrevented, t.isPropagationStopped = () => t.cancelBubble, t.persist = () => {
  }, t;
}
function an(e, t) {
  Object.defineProperty(e, "target", {
    value: t
  }), Object.defineProperty(e, "currentTarget", {
    value: t
  });
}
function sn(e) {
  let t = I({
    isFocused: !1,
    observer: null
  });
  q(() => {
    const r = t.current;
    return () => {
      r.observer && (r.observer.disconnect(), r.observer = null);
    };
  }, []);
  let n = oe((r) => {
    e?.(r);
  });
  return N((r) => {
    if (r.target instanceof HTMLButtonElement || r.target instanceof HTMLInputElement || r.target instanceof HTMLTextAreaElement || r.target instanceof HTMLSelectElement) {
      t.current.isFocused = !0;
      let o = r.target, i = (a) => {
        if (t.current.isFocused = !1, o.disabled) {
          let l = bt(a);
          n(l);
        }
        t.current.observer && (t.current.observer.disconnect(), t.current.observer = null);
      };
      o.addEventListener("focusout", i, {
        once: !0
      }), t.current.observer = new MutationObserver(() => {
        if (t.current.isFocused && o.disabled) {
          var a;
          (a = t.current.observer) === null || a === void 0 || a.disconnect();
          let l = o === document.activeElement ? null : document.activeElement;
          o.dispatchEvent(new FocusEvent("blur", {
            relatedTarget: l
          })), o.dispatchEvent(new FocusEvent("focusout", {
            bubbles: !0,
            relatedTarget: l
          }));
        }
      }), t.current.observer.observe(o, {
        attributes: !0,
        attributeFilter: [
          "disabled"
        ]
      });
    }
  }, [
    n
  ]);
}
let He = !1;
function Tt(e) {
  for (; e && !on(e); ) e = e.parentElement;
  let t = X(e), n = t.document.activeElement;
  if (!n || n === e) return;
  He = !0;
  let r = !1, o = (f) => {
    (f.target === n || r) && f.stopImmediatePropagation();
  }, i = (f) => {
    (f.target === n || r) && (f.stopImmediatePropagation(), !e && !r && (r = !0, ve(n), u()));
  }, a = (f) => {
    (f.target === e || r) && f.stopImmediatePropagation();
  }, l = (f) => {
    (f.target === e || r) && (f.stopImmediatePropagation(), r || (r = !0, ve(n), u()));
  };
  t.addEventListener("blur", o, !0), t.addEventListener("focusout", i, !0), t.addEventListener("focusin", l, !0), t.addEventListener("focus", a, !0);
  let u = () => {
    cancelAnimationFrame(d), t.removeEventListener("blur", o, !0), t.removeEventListener("focusout", i, !0), t.removeEventListener("focusin", l, !0), t.removeEventListener("focus", a, !0), He = !1, r = !1;
  }, d = requestAnimationFrame(u);
  return u;
}
let de = "default", Je = "", Ie = /* @__PURE__ */ new WeakMap();
function wt(e) {
  if (dt()) {
    if (de === "default") {
      const t = z(e);
      Je = t.documentElement.style.webkitUserSelect, t.documentElement.style.webkitUserSelect = "none";
    }
    de = "disabled";
  } else if (e instanceof HTMLElement || e instanceof SVGElement) {
    let t = "userSelect" in e.style ? "userSelect" : "webkitUserSelect";
    Ie.set(e, e.style[t]), e.style[t] = "none";
  }
}
function We(e) {
  if (dt()) {
    if (de !== "disabled") return;
    de = "restoring", setTimeout(() => {
      en(() => {
        if (de === "restoring") {
          const t = z(e);
          t.documentElement.style.webkitUserSelect === "none" && (t.documentElement.style.webkitUserSelect = Je || ""), Je = "", de = "default";
        }
      });
    }, 300);
  } else if ((e instanceof HTMLElement || e instanceof SVGElement) && e && Ie.has(e)) {
    let t = Ie.get(e), n = "userSelect" in e.style ? "userSelect" : "webkitUserSelect";
    e.style[n] === "none" && (e.style[n] = t), e.getAttribute("style") === "" && e.removeAttribute("style"), Ie.delete(e);
  }
}
const cn = x.createContext({
  register: () => {
  }
});
cn.displayName = "PressResponderContext";
function Pr(e, t) {
  return t.get ? t.get.call(e) : t.value;
}
function un(e, t, n) {
  if (!t.has(e)) throw new TypeError("attempted to " + n + " private field on non-instance");
  return t.get(e);
}
function Er(e, t) {
  var n = un(e, t, "get");
  return Pr(e, n);
}
function Tr(e, t) {
  if (t.has(e))
    throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function wr(e, t, n) {
  Tr(e, t), t.set(e, n);
}
function xr(e, t, n) {
  if (t.set) t.set.call(e, n);
  else {
    if (!t.writable)
      throw new TypeError("attempted to set read only private field");
    t.value = n;
  }
}
function xt(e, t, n) {
  var r = un(e, t, "set");
  return xr(e, r, n), n;
}
function Sr(e) {
  let t = W(cn);
  if (t) {
    let { register: n, ...r } = t;
    e = _(r, e), n();
  }
  return tn(t, e.ref), e;
}
var Oe = /* @__PURE__ */ new WeakMap();
class Me {
  continuePropagation() {
    xt(this, Oe, !1);
  }
  get shouldStopPropagation() {
    return Er(this, Oe);
  }
  constructor(t, n, r, o) {
    wr(this, Oe, {
      writable: !0,
      value: void 0
    }), xt(this, Oe, !0);
    var i;
    let a = (i = o?.target) !== null && i !== void 0 ? i : r.currentTarget;
    const l = a?.getBoundingClientRect();
    let u, d = 0, f, p = null;
    r.clientX != null && r.clientY != null && (f = r.clientX, p = r.clientY), l && (f != null && p != null ? (u = f - l.left, d = p - l.top) : (u = l.width / 2, d = l.height / 2)), this.type = t, this.pointerType = n, this.target = r.currentTarget, this.shiftKey = r.shiftKey, this.metaKey = r.metaKey, this.ctrlKey = r.ctrlKey, this.altKey = r.altKey, this.x = u, this.y = d;
  }
}
const St = Symbol("linkClicked"), Lt = "react-aria-pressable-style", Ct = "data-react-aria-pressable";
function dn(e) {
  let { onPress: t, onPressChange: n, onPressStart: r, onPressEnd: o, onPressUp: i, onClick: a, isDisabled: l, isPressed: u, preventFocusOnPress: d, shouldCancelOnPointerExit: f, allowTextSelectionOnPress: p, ref: g, ...v } = Sr(e), [m, $] = G(!1), y = I({
    isPressed: !1,
    ignoreEmulatedMouseEvents: !1,
    didFirePressStart: !1,
    isTriggeringEvent: !1,
    activePointerId: null,
    target: null,
    isOverTarget: !1,
    pointerType: null,
    disposables: []
  }), { addGlobalListener: h, removeAllGlobalListeners: E } = ft(), L = oe((s, P) => {
    let F = y.current;
    if (l || F.didFirePressStart) return !1;
    let b = !0;
    if (F.isTriggeringEvent = !0, r) {
      let C = new Me("pressstart", P, s);
      r(C), b = C.shouldStopPropagation;
    }
    return n && n(!0), F.isTriggeringEvent = !1, F.didFirePressStart = !0, $(!0), b;
  }), O = oe((s, P, F = !0) => {
    let b = y.current;
    if (!b.didFirePressStart) return !1;
    b.didFirePressStart = !1, b.isTriggeringEvent = !0;
    let C = !0;
    if (o) {
      let c = new Me("pressend", P, s);
      o(c), C = c.shouldStopPropagation;
    }
    if (n && n(!1), $(!1), t && F && !l) {
      let c = new Me("press", P, s);
      t(c), C && (C = c.shouldStopPropagation);
    }
    return b.isTriggeringEvent = !1, C;
  }), M = oe((s, P) => {
    let F = y.current;
    if (l) return !1;
    if (i) {
      F.isTriggeringEvent = !0;
      let b = new Me("pressup", P, s);
      return i(b), F.isTriggeringEvent = !1, b.shouldStopPropagation;
    }
    return !0;
  }), S = oe((s) => {
    let P = y.current;
    if (P.isPressed && P.target) {
      P.didFirePressStart && P.pointerType != null && O(le(P.target, s), P.pointerType, !1), P.isPressed = !1, P.isOverTarget = !1, P.activePointerId = null, P.pointerType = null, E(), p || We(P.target);
      for (let F of P.disposables) F();
      P.disposables = [];
    }
  }), B = oe((s) => {
    f && S(s);
  }), j = oe((s) => {
    a?.(s);
  }), U = oe((s, P) => {
    if (a) {
      let F = new MouseEvent("click", s);
      an(F, P), a(bt(F));
    }
  }), H = te(() => {
    let s = y.current, P = {
      onKeyDown(b) {
        if (je(b.nativeEvent, b.currentTarget) && k(b.currentTarget, D(b.nativeEvent))) {
          var C;
          Mt(D(b.nativeEvent), b.key) && b.preventDefault();
          let c = !0;
          if (!s.isPressed && !b.repeat) {
            s.target = b.currentTarget, s.isPressed = !0, s.pointerType = "keyboard", c = L(b, "keyboard");
            let T = b.currentTarget, w = (V) => {
              je(V, T) && !V.repeat && k(T, D(V)) && s.target && M(le(s.target, V), "keyboard");
            };
            h(z(b.currentTarget), "keyup", st(w, F), !0);
          }
          c && b.stopPropagation(), b.metaKey && $e() && ((C = s.metaKeyEvents) === null || C === void 0 || C.set(b.key, b.nativeEvent));
        } else b.key === "Meta" && (s.metaKeyEvents = /* @__PURE__ */ new Map());
      },
      onClick(b) {
        if (!(b && !k(b.currentTarget, D(b.nativeEvent))) && b && b.button === 0 && !s.isTriggeringEvent && !ce.isOpening) {
          let C = !0;
          if (l && b.preventDefault(), !s.ignoreEmulatedMouseEvents && !s.isPressed && (s.pointerType === "virtual" || qe(b.nativeEvent))) {
            let c = L(b, "virtual"), T = M(b, "virtual"), w = O(b, "virtual");
            j(b), C = c && T && w;
          } else if (s.isPressed && s.pointerType !== "keyboard") {
            let c = s.pointerType || b.nativeEvent.pointerType || "virtual", T = M(le(b.currentTarget, b), c), w = O(le(b.currentTarget, b), c, !0);
            C = T && w, s.isOverTarget = !1, j(b), S(b);
          }
          s.ignoreEmulatedMouseEvents = !1, C && b.stopPropagation();
        }
      }
    }, F = (b) => {
      var C;
      if (s.isPressed && s.target && je(b, s.target)) {
        var c;
        Mt(D(b), b.key) && b.preventDefault();
        let w = D(b), V = k(s.target, D(b));
        O(le(s.target, b), "keyboard", V), V && U(b, s.target), E(), b.key !== "Enter" && vt(s.target) && k(s.target, w) && !b[St] && (b[St] = !0, ce(s.target, b, !1)), s.isPressed = !1, (c = s.metaKeyEvents) === null || c === void 0 || c.delete(b.key);
      } else if (b.key === "Meta" && (!((C = s.metaKeyEvents) === null || C === void 0) && C.size)) {
        var T;
        let w = s.metaKeyEvents;
        s.metaKeyEvents = void 0;
        for (let V of w.values()) (T = s.target) === null || T === void 0 || T.dispatchEvent(new KeyboardEvent("keyup", V));
      }
    };
    if (typeof PointerEvent < "u") {
      P.onPointerDown = (c) => {
        if (c.button !== 0 || !k(c.currentTarget, D(c.nativeEvent))) return;
        if (dr(c.nativeEvent)) {
          s.pointerType = "virtual";
          return;
        }
        s.pointerType = c.pointerType;
        let T = !0;
        if (!s.isPressed) {
          s.isPressed = !0, s.isOverTarget = !0, s.activePointerId = c.pointerId, s.target = c.currentTarget, p || wt(s.target), T = L(c, s.pointerType);
          let w = D(c.nativeEvent);
          "releasePointerCapture" in w && w.releasePointerCapture(c.pointerId), h(z(c.currentTarget), "pointerup", b, !1), h(z(c.currentTarget), "pointercancel", C, !1);
        }
        T && c.stopPropagation();
      }, P.onMouseDown = (c) => {
        if (k(c.currentTarget, D(c.nativeEvent)) && c.button === 0) {
          if (d) {
            let T = Tt(c.target);
            T && s.disposables.push(T);
          }
          c.stopPropagation();
        }
      }, P.onPointerUp = (c) => {
        !k(c.currentTarget, D(c.nativeEvent)) || s.pointerType === "virtual" || c.button === 0 && !s.isPressed && M(c, s.pointerType || c.pointerType);
      }, P.onPointerEnter = (c) => {
        c.pointerId === s.activePointerId && s.target && !s.isOverTarget && s.pointerType != null && (s.isOverTarget = !0, L(le(s.target, c), s.pointerType));
      }, P.onPointerLeave = (c) => {
        c.pointerId === s.activePointerId && s.target && s.isOverTarget && s.pointerType != null && (s.isOverTarget = !1, O(le(s.target, c), s.pointerType, !1), B(c));
      };
      let b = (c) => {
        if (c.pointerId === s.activePointerId && s.isPressed && c.button === 0 && s.target) {
          if (k(s.target, D(c)) && s.pointerType != null) {
            let T = !1, w = setTimeout(() => {
              s.isPressed && s.target instanceof HTMLElement && (T ? S(c) : (ve(s.target), s.target.click()));
            }, 80);
            h(c.currentTarget, "click", () => T = !0, !0), s.disposables.push(() => clearTimeout(w));
          } else S(c);
          s.isOverTarget = !1;
        }
      }, C = (c) => {
        S(c);
      };
      P.onDragStart = (c) => {
        k(c.currentTarget, D(c.nativeEvent)) && S(c);
      };
    } else if (process.env.NODE_ENV === "test") {
      P.onMouseDown = (c) => {
        if (c.button !== 0 || !k(c.currentTarget, D(c.nativeEvent))) return;
        if (s.ignoreEmulatedMouseEvents) {
          c.stopPropagation();
          return;
        }
        if (s.isPressed = !0, s.isOverTarget = !0, s.target = c.currentTarget, s.pointerType = qe(c.nativeEvent) ? "virtual" : "mouse", Bt(() => L(c, s.pointerType)) && c.stopPropagation(), d) {
          let w = Tt(c.target);
          w && s.disposables.push(w);
        }
        h(z(c.currentTarget), "mouseup", b, !1);
      }, P.onMouseEnter = (c) => {
        if (!k(c.currentTarget, D(c.nativeEvent))) return;
        let T = !0;
        s.isPressed && !s.ignoreEmulatedMouseEvents && s.pointerType != null && (s.isOverTarget = !0, T = L(c, s.pointerType)), T && c.stopPropagation();
      }, P.onMouseLeave = (c) => {
        if (!k(c.currentTarget, D(c.nativeEvent))) return;
        let T = !0;
        s.isPressed && !s.ignoreEmulatedMouseEvents && s.pointerType != null && (s.isOverTarget = !1, T = O(c, s.pointerType, !1), B(c)), T && c.stopPropagation();
      }, P.onMouseUp = (c) => {
        k(c.currentTarget, D(c.nativeEvent)) && !s.ignoreEmulatedMouseEvents && c.button === 0 && !s.isPressed && M(c, s.pointerType || "mouse");
      };
      let b = (c) => {
        if (c.button === 0) {
          if (s.ignoreEmulatedMouseEvents) {
            s.ignoreEmulatedMouseEvents = !1;
            return;
          }
          s.target && s.target.contains(c.target) && s.pointerType != null || S(c), s.isOverTarget = !1;
        }
      };
      P.onTouchStart = (c) => {
        if (!k(c.currentTarget, D(c.nativeEvent))) return;
        let T = Lr(c.nativeEvent);
        if (!T) return;
        s.activePointerId = T.identifier, s.ignoreEmulatedMouseEvents = !0, s.isOverTarget = !0, s.isPressed = !0, s.target = c.currentTarget, s.pointerType = "touch", p || wt(s.target), L(re(s.target, c), s.pointerType) && c.stopPropagation(), h(X(c.currentTarget), "scroll", C, !0);
      }, P.onTouchMove = (c) => {
        if (!k(c.currentTarget, D(c.nativeEvent))) return;
        if (!s.isPressed) {
          c.stopPropagation();
          return;
        }
        let T = Ft(c.nativeEvent, s.activePointerId), w = !0;
        T && Ot(T, c.currentTarget) ? !s.isOverTarget && s.pointerType != null && (s.isOverTarget = !0, w = L(re(s.target, c), s.pointerType)) : s.isOverTarget && s.pointerType != null && (s.isOverTarget = !1, w = O(re(s.target, c), s.pointerType, !1), B(re(s.target, c))), w && c.stopPropagation();
      }, P.onTouchEnd = (c) => {
        if (!k(c.currentTarget, D(c.nativeEvent))) return;
        if (!s.isPressed) {
          c.stopPropagation();
          return;
        }
        let T = Ft(c.nativeEvent, s.activePointerId), w = !0;
        T && Ot(T, c.currentTarget) && s.pointerType != null ? (M(re(s.target, c), s.pointerType), w = O(re(s.target, c), s.pointerType), U(c.nativeEvent, s.target)) : s.isOverTarget && s.pointerType != null && (w = O(re(s.target, c), s.pointerType, !1)), w && c.stopPropagation(), s.isPressed = !1, s.activePointerId = null, s.isOverTarget = !1, s.ignoreEmulatedMouseEvents = !0, s.target && !p && We(s.target), E();
      }, P.onTouchCancel = (c) => {
        k(c.currentTarget, D(c.nativeEvent)) && (c.stopPropagation(), s.isPressed && S(re(s.target, c)));
      };
      let C = (c) => {
        s.isPressed && k(D(c), s.target) && S({
          currentTarget: s.target,
          shiftKey: !1,
          ctrlKey: !1,
          metaKey: !1,
          altKey: !1
        });
      };
      P.onDragStart = (c) => {
        k(c.currentTarget, D(c.nativeEvent)) && S(c);
      };
    }
    return P;
  }, [
    h,
    l,
    d,
    E,
    p,
    S,
    B,
    O,
    L,
    M,
    j,
    U
  ]);
  return K(() => {
    if (!g || process.env.NODE_ENV === "test") return;
    const s = z(g.current);
    if (!s || !s.head || s.getElementById(Lt)) return;
    const P = s.createElement("style");
    P.id = Lt, P.textContent = `
@layer {
  [${Ct}] {
    touch-action: pan-x pan-y pinch-zoom;
  }
}
    `.trim(), s.head.prepend(P);
  }, [
    g
  ]), K(() => {
    let s = y.current;
    return () => {
      var P;
      p || We((P = s.target) !== null && P !== void 0 ? P : void 0);
      for (let F of s.disposables) F();
      s.disposables = [];
    };
  }, [
    p
  ]), {
    isPressed: u || m,
    pressProps: _(v, H, {
      [Ct]: !0
    })
  };
}
function vt(e) {
  return e.tagName === "A" && e.hasAttribute("href");
}
function je(e, t) {
  const { key: n, code: r } = e, o = t, i = o.getAttribute("role");
  return (n === "Enter" || n === " " || n === "Spacebar" || r === "Space") && !(o instanceof X(o).HTMLInputElement && !fn(o, n) || o instanceof X(o).HTMLTextAreaElement || o.isContentEditable) && // Links should only trigger with Enter key
  !((i === "link" || !i && vt(o)) && n !== "Enter");
}
function Lr(e) {
  const { targetTouches: t } = e;
  return t.length > 0 ? t[0] : null;
}
function Ft(e, t) {
  const n = e.changedTouches;
  for (let r = 0; r < n.length; r++) {
    const o = n[r];
    if (o.identifier === t) return o;
  }
  return null;
}
function re(e, t) {
  let n = 0, r = 0;
  return t.targetTouches && t.targetTouches.length === 1 && (n = t.targetTouches[0].clientX, r = t.targetTouches[0].clientY), {
    currentTarget: e,
    shiftKey: t.shiftKey,
    ctrlKey: t.ctrlKey,
    metaKey: t.metaKey,
    altKey: t.altKey,
    clientX: n,
    clientY: r
  };
}
function le(e, t) {
  let n = t.clientX, r = t.clientY;
  return {
    currentTarget: e,
    shiftKey: t.shiftKey,
    ctrlKey: t.ctrlKey,
    metaKey: t.metaKey,
    altKey: t.altKey,
    clientX: n,
    clientY: r
  };
}
function Cr(e) {
  let t = 0, n = 0;
  return e.width !== void 0 ? t = e.width / 2 : e.radiusX !== void 0 && (t = e.radiusX), e.height !== void 0 ? n = e.height / 2 : e.radiusY !== void 0 && (n = e.radiusY), {
    top: e.clientY - n,
    right: e.clientX + t,
    bottom: e.clientY + n,
    left: e.clientX - t
  };
}
function Fr(e, t) {
  return !(e.left > t.right || t.left > e.right || e.top > t.bottom || t.top > e.bottom);
}
function Ot(e, t) {
  let n = t.getBoundingClientRect(), r = Cr(e);
  return Fr(n, r);
}
function Or(e) {
  return e instanceof HTMLInputElement ? !1 : e instanceof HTMLButtonElement ? e.type !== "submit" && e.type !== "reset" : !vt(e);
}
function Mt(e, t) {
  return e instanceof HTMLInputElement ? !fn(e, t) : Or(e);
}
const Mr = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
function fn(e, t) {
  return e.type === "checkbox" || e.type === "radio" ? t === " " : Mr.has(e.type);
}
let me = null, Qe = /* @__PURE__ */ new Set(), Ee = /* @__PURE__ */ new Map(), ue = !1, et = !1;
const Dr = {
  Tab: !0,
  Escape: !0
};
function $t(e, t) {
  for (let n of Qe) n(e, t);
}
function Ir(e) {
  return !(e.metaKey || !$e() && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function Ae(e) {
  ue = !0, Ir(e) && (me = "keyboard", $t("keyboard", e));
}
function Y(e) {
  me = "pointer", (e.type === "mousedown" || e.type === "pointerdown") && (ue = !0, $t("pointer", e));
}
function pn(e) {
  qe(e) && (ue = !0, me = "virtual");
}
function bn(e) {
  e.target === window || e.target === document || He || !e.isTrusted || (!ue && !et && (me = "virtual", $t("virtual", e)), ue = !1, et = !1);
}
function vn() {
  He || (ue = !1, et = !0);
}
function tt(e) {
  if (typeof window > "u" || typeof document > "u" || Ee.get(X(e))) return;
  const t = X(e), n = z(e);
  let r = t.HTMLElement.prototype.focus;
  t.HTMLElement.prototype.focus = function() {
    ue = !0, r.apply(this, arguments);
  }, n.addEventListener("keydown", Ae, !0), n.addEventListener("keyup", Ae, !0), n.addEventListener("click", pn, !0), t.addEventListener("focus", bn, !0), t.addEventListener("blur", vn, !1), typeof PointerEvent < "u" ? (n.addEventListener("pointerdown", Y, !0), n.addEventListener("pointermove", Y, !0), n.addEventListener("pointerup", Y, !0)) : process.env.NODE_ENV === "test" && (n.addEventListener("mousedown", Y, !0), n.addEventListener("mousemove", Y, !0), n.addEventListener("mouseup", Y, !0)), t.addEventListener("beforeunload", () => {
    $n(e);
  }, {
    once: !0
  }), Ee.set(t, {
    focus: r
  });
}
const $n = (e, t) => {
  const n = X(e), r = z(e);
  t && r.removeEventListener("DOMContentLoaded", t), Ee.has(n) && (n.HTMLElement.prototype.focus = Ee.get(n).focus, r.removeEventListener("keydown", Ae, !0), r.removeEventListener("keyup", Ae, !0), r.removeEventListener("click", pn, !0), n.removeEventListener("focus", bn, !0), n.removeEventListener("blur", vn, !1), typeof PointerEvent < "u" ? (r.removeEventListener("pointerdown", Y, !0), r.removeEventListener("pointermove", Y, !0), r.removeEventListener("pointerup", Y, !0)) : process.env.NODE_ENV === "test" && (r.removeEventListener("mousedown", Y, !0), r.removeEventListener("mousemove", Y, !0), r.removeEventListener("mouseup", Y, !0)), Ee.delete(n));
};
function kr(e) {
  const t = z(e);
  let n;
  return t.readyState !== "loading" ? tt(e) : (n = () => {
    tt(e);
  }, t.addEventListener("DOMContentLoaded", n)), () => $n(e, n);
}
typeof document < "u" && kr();
function gt() {
  return me !== "pointer";
}
function gn() {
  return me;
}
const Hr = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
function Ar(e, t, n) {
  let r = z(n?.target);
  const o = typeof window < "u" ? X(n?.target).HTMLInputElement : HTMLInputElement, i = typeof window < "u" ? X(n?.target).HTMLTextAreaElement : HTMLTextAreaElement, a = typeof window < "u" ? X(n?.target).HTMLElement : HTMLElement, l = typeof window < "u" ? X(n?.target).KeyboardEvent : KeyboardEvent;
  return e = e || r.activeElement instanceof o && !Hr.has(r.activeElement.type) || r.activeElement instanceof i || r.activeElement instanceof a && r.activeElement.isContentEditable, !(e && t === "keyboard" && n instanceof l && !Dr[n.key]);
}
function Nr(e, t, n) {
  tt(), K(() => {
    let r = (o, i) => {
      Ar(!!n?.isTextInput, o, i) && e(gt());
    };
    return Qe.add(r), () => {
      Qe.delete(r);
    };
  }, t);
}
function Rr(e) {
  const t = z(e), n = Te(t);
  if (gn() === "virtual") {
    let r = n;
    en(() => {
      Te(t) === r && e.isConnected && ve(e);
    });
  } else ve(e);
}
function mn(e) {
  let { isDisabled: t, onFocus: n, onBlur: r, onFocusChange: o } = e;
  const i = N((u) => {
    if (u.target === u.currentTarget)
      return r && r(u), o && o(!1), !0;
  }, [
    r,
    o
  ]), a = sn(i), l = N((u) => {
    const d = z(u.target), f = d ? Te(d) : Te();
    u.target === u.currentTarget && f === D(u.nativeEvent) && (n && n(u), o && o(!0), a(u));
  }, [
    o,
    n,
    a
  ]);
  return {
    focusProps: {
      onFocus: !t && (n || o || r) ? l : void 0,
      onBlur: !t && (r || o) ? i : void 0
    }
  };
}
function Dt(e) {
  if (!e) return;
  let t = !0;
  return (n) => {
    let r = {
      ...n,
      preventDefault() {
        n.preventDefault();
      },
      isDefaultPrevented() {
        return n.isDefaultPrevented();
      },
      stopPropagation() {
        t && process.env.NODE_ENV !== "production" ? console.error("stopPropagation is now the default behavior for events in React Spectrum. You can use continuePropagation() to revert this behavior.") : t = !0;
      },
      continuePropagation() {
        t = !1;
      },
      isPropagationStopped() {
        return t;
      }
    };
    e(r), t && n.stopPropagation();
  };
}
function Kr(e) {
  return {
    keyboardProps: e.isDisabled ? {} : {
      onKeyDown: Dt(e.onKeyDown),
      onKeyUp: Dt(e.onKeyUp)
    }
  };
}
let hn = /* @__PURE__ */ x.createContext(null);
function _r(e) {
  let t = W(hn) || {};
  tn(t, e);
  let { ref: n, ...r } = t;
  return r;
}
const Vr = /* @__PURE__ */ x.forwardRef(function(t, n) {
  let { children: r, ...o } = t, i = pt(n), a = {
    ...o,
    ref: i
  };
  return /* @__PURE__ */ x.createElement(hn.Provider, {
    value: a
  }, r);
});
function Ve(e, t) {
  let { focusProps: n } = mn(e), { keyboardProps: r } = Kr(e), o = _(n, r), i = _r(t), a = e.isDisabled ? {} : i, l = I(e.autoFocus);
  K(() => {
    l.current && t.current && Rr(t.current), l.current = !1;
  }, [
    t
  ]);
  let u = e.excludeFromTabOrder ? -1 : 0;
  return e.isDisabled && (u = void 0), {
    focusableProps: _({
      ...o,
      tabIndex: u
    }, a)
  };
}
const Uo = /* @__PURE__ */ ge(({ children: e, ...t }, n) => {
  n = pt(n);
  let { focusableProps: r } = Ve(t, n), o = x.Children.only(e);
  K(() => {
    if (process.env.NODE_ENV === "production") return;
    let a = n.current;
    if (!a || !(a instanceof X(a).Element)) {
      console.error("<Focusable> child must forward its ref to a DOM element.");
      return;
    }
    if (!t.isDisabled && !on(a)) {
      console.warn("<Focusable> child must be focusable. Please ensure the tabIndex prop is passed through.");
      return;
    }
    if (a.localName !== "button" && a.localName !== "input" && a.localName !== "select" && a.localName !== "textarea" && a.localName !== "a" && a.localName !== "area" && a.localName !== "summary" && a.localName !== "img" && a.localName !== "svg") {
      let l = a.getAttribute("role");
      l ? (
        // https://w3c.github.io/aria/#widget_roles
        l !== "application" && l !== "button" && l !== "checkbox" && l !== "combobox" && l !== "gridcell" && l !== "link" && l !== "menuitem" && l !== "menuitemcheckbox" && l !== "menuitemradio" && l !== "option" && l !== "radio" && l !== "searchbox" && l !== "separator" && l !== "slider" && l !== "spinbutton" && l !== "switch" && l !== "tab" && l !== "tabpanel" && l !== "textbox" && l !== "treeitem" && // aria-describedby is also announced on these roles
        l !== "img" && l !== "meter" && l !== "progressbar" && console.warn(`<Focusable> child must have an interactive ARIA role. Got "${l}".`)
      ) : console.warn("<Focusable> child must have an interactive ARIA role.");
    }
  }, [
    n,
    t.isDisabled
  ]);
  let i = parseInt(x.version, 10) < 19 ? o.ref : o.props.ref;
  return /* @__PURE__ */ x.cloneElement(o, {
    ..._(r, o.props),
    // @ts-ignore
    ref: jt(i, n)
  });
});
function zr(e) {
  let { isDisabled: t, onBlurWithin: n, onFocusWithin: r, onFocusWithinChange: o } = e, i = I({
    isFocusWithin: !1
  }), { addGlobalListener: a, removeAllGlobalListeners: l } = ft(), u = N((p) => {
    p.currentTarget.contains(p.target) && i.current.isFocusWithin && !p.currentTarget.contains(p.relatedTarget) && (i.current.isFocusWithin = !1, l(), n && n(p), o && o(!1));
  }, [
    n,
    o,
    i,
    l
  ]), d = sn(u), f = N((p) => {
    if (!p.currentTarget.contains(p.target)) return;
    const g = z(p.target), v = Te(g);
    if (!i.current.isFocusWithin && v === D(p.nativeEvent)) {
      r && r(p), o && o(!0), i.current.isFocusWithin = !0, d(p);
      let m = p.currentTarget;
      a(g, "focus", ($) => {
        if (i.current.isFocusWithin && !k(m, $.target)) {
          let y = new g.defaultView.FocusEvent("blur", {
            relatedTarget: $.target
          });
          an(y, m);
          let h = bt(y);
          u(h);
        }
      }, {
        capture: !0
      });
    }
  }, [
    r,
    o,
    d,
    a,
    u
  ]);
  return t ? {
    focusWithinProps: {
      // These cannot be null, that would conflict in mergeProps
      onFocus: void 0,
      onBlur: void 0
    }
  } : {
    focusWithinProps: {
      onFocus: f,
      onBlur: u
    }
  };
}
let Ne = !1, Ge = 0;
function nt() {
  Ne = !0, setTimeout(() => {
    Ne = !1;
  }, 50);
}
function It(e) {
  e.pointerType === "touch" && nt();
}
function Br() {
  if (!(typeof document > "u"))
    return typeof PointerEvent < "u" ? document.addEventListener("pointerup", It) : process.env.NODE_ENV === "test" && document.addEventListener("touchend", nt), Ge++, () => {
      Ge--, !(Ge > 0) && (typeof PointerEvent < "u" ? document.removeEventListener("pointerup", It) : process.env.NODE_ENV === "test" && document.removeEventListener("touchend", nt));
    };
}
function Ce(e) {
  let { onHoverStart: t, onHoverChange: n, onHoverEnd: r, isDisabled: o } = e, [i, a] = G(!1), l = I({
    isHovered: !1,
    ignoreEmulatedMouseEvents: !1,
    pointerType: "",
    target: null
  }).current;
  K(Br, []);
  let { addGlobalListener: u, removeAllGlobalListeners: d } = ft(), { hoverProps: f, triggerHoverEnd: p } = te(() => {
    let g = ($, y) => {
      if (l.pointerType = y, o || y === "touch" || l.isHovered || !$.currentTarget.contains($.target)) return;
      l.isHovered = !0;
      let h = $.currentTarget;
      l.target = h, u(z($.target), "pointerover", (E) => {
        l.isHovered && l.target && !k(l.target, E.target) && v(E, E.pointerType);
      }, {
        capture: !0
      }), t && t({
        type: "hoverstart",
        target: h,
        pointerType: y
      }), n && n(!0), a(!0);
    }, v = ($, y) => {
      let h = l.target;
      l.pointerType = "", l.target = null, !(y === "touch" || !l.isHovered || !h) && (l.isHovered = !1, d(), r && r({
        type: "hoverend",
        target: h,
        pointerType: y
      }), n && n(!1), a(!1));
    }, m = {};
    return typeof PointerEvent < "u" ? (m.onPointerEnter = ($) => {
      Ne && $.pointerType === "mouse" || g($, $.pointerType);
    }, m.onPointerLeave = ($) => {
      !o && $.currentTarget.contains($.target) && v($, $.pointerType);
    }) : process.env.NODE_ENV === "test" && (m.onTouchStart = () => {
      l.ignoreEmulatedMouseEvents = !0;
    }, m.onMouseEnter = ($) => {
      !l.ignoreEmulatedMouseEvents && !Ne && g($, "mouse"), l.ignoreEmulatedMouseEvents = !1;
    }, m.onMouseLeave = ($) => {
      !o && $.currentTarget.contains($.target) && v($, "mouse");
    }), {
      hoverProps: m,
      triggerHoverEnd: v
    };
  }, [
    t,
    n,
    r,
    o,
    l,
    u,
    d
  ]);
  return K(() => {
    o && p({
      currentTarget: l.target
    }, l.pointerType);
  }, [
    o
  ]), {
    hoverProps: f,
    isHovered: i
  };
}
function Ur(e, t) {
  let { elementType: n = "a", onPress: r, onPressStart: o, onPressEnd: i, onClick: a, isDisabled: l, ...u } = e, d = {};
  n !== "a" && (d = {
    role: "link",
    tabIndex: l ? void 0 : 0
  });
  let { focusableProps: f } = Ve(e, t), { pressProps: p, isPressed: g } = dn({
    onPress: r,
    onPressStart: o,
    onPressEnd: i,
    onClick: a,
    isDisabled: l,
    ref: t
  }), v = xe(u, {
    labelable: !0
  }), m = _(f, p), $ = qt(), y = ar(e);
  return {
    isPressed: g,
    linkProps: _(v, y, {
      ...m,
      ...d,
      "aria-disabled": l || void 0,
      "aria-current": e["aria-current"],
      onClick: (h) => {
        var E;
        (E = p.onClick) === null || E === void 0 || E.call(p, h), !$.isNative && h.currentTarget instanceof HTMLAnchorElement && h.currentTarget.href && // If props are applied to a router Link component, it may have already prevented default.
        !h.isDefaultPrevented() && Jt(h.currentTarget, h) && e.href && (h.preventDefault(), $.open(h.currentTarget, h, e.href, e.routerOptions));
      }
    })
  };
}
const Wr = /* @__PURE__ */ new Set([
  "Arab",
  "Syrc",
  "Samr",
  "Mand",
  "Thaa",
  "Mend",
  "Nkoo",
  "Adlm",
  "Rohg",
  "Hebr"
]), jr = /* @__PURE__ */ new Set([
  "ae",
  "ar",
  "arc",
  "bcc",
  "bqi",
  "ckb",
  "dv",
  "fa",
  "glk",
  "he",
  "ku",
  "mzn",
  "nqo",
  "pnb",
  "ps",
  "sd",
  "ug",
  "ur",
  "yi"
]);
function Gr(e) {
  if (Intl.Locale) {
    let n = new Intl.Locale(e).maximize(), r = typeof n.getTextInfo == "function" ? n.getTextInfo() : n.textInfo;
    if (r) return r.direction === "rtl";
    if (n.script) return Wr.has(n.script);
  }
  let t = e.split("-")[0];
  return jr.has(t);
}
const Yr = Symbol.for("react-aria.i18n.locale");
function yn() {
  let e = typeof window < "u" && window[Yr] || typeof navigator < "u" && (navigator.language || navigator.userLanguage) || "en-US";
  try {
    Intl.DateTimeFormat.supportedLocalesOf([
      e
    ]);
  } catch {
    e = "en-US";
  }
  return {
    locale: e,
    direction: Gr(e) ? "rtl" : "ltr"
  };
}
let rt = yn(), Pe = /* @__PURE__ */ new Set();
function kt() {
  rt = yn();
  for (let e of Pe) e(rt);
}
function Xr() {
  let e = at(), [t, n] = G(rt);
  return K(() => (Pe.size === 0 && window.addEventListener("languagechange", kt), Pe.add(n), () => {
    Pe.delete(n), Pe.size === 0 && window.removeEventListener("languagechange", kt);
  }), []), e ? {
    locale: "en-US",
    direction: "ltr"
  } : t;
}
const Zr = /* @__PURE__ */ x.createContext(null);
function Pn() {
  let e = Xr();
  return W(Zr) || e;
}
let Ye = /* @__PURE__ */ new Map(), ot = !1;
try {
  ot = new Intl.NumberFormat("de-DE", {
    signDisplay: "exceptZero"
  }).resolvedOptions().signDisplay === "exceptZero";
} catch {
}
let Re = !1;
try {
  Re = new Intl.NumberFormat("de-DE", {
    style: "unit",
    unit: "degree"
  }).resolvedOptions().style === "unit";
} catch {
}
const En = {
  degree: {
    narrow: {
      default: "°",
      "ja-JP": " 度",
      "zh-TW": "度",
      "sl-SI": " °"
    }
  }
};
class qr {
  /** Formats a number value as a string, according to the locale and options provided to the constructor. */
  format(t) {
    let n = "";
    if (!ot && this.options.signDisplay != null ? n = Qr(this.numberFormatter, this.options.signDisplay, t) : n = this.numberFormatter.format(t), this.options.style === "unit" && !Re) {
      var r;
      let { unit: o, unitDisplay: i = "short", locale: a } = this.resolvedOptions();
      if (!o) return n;
      let l = (r = En[o]) === null || r === void 0 ? void 0 : r[i];
      n += l[a] || l.default;
    }
    return n;
  }
  /** Formats a number to an array of parts such as separators, digits, punctuation, and more. */
  formatToParts(t) {
    return this.numberFormatter.formatToParts(t);
  }
  /** Formats a number range as a string. */
  formatRange(t, n) {
    if (typeof this.numberFormatter.formatRange == "function") return this.numberFormatter.formatRange(t, n);
    if (n < t) throw new RangeError("End date must be >= start date");
    return `${this.format(t)} – ${this.format(n)}`;
  }
  /** Formats a number range as an array of parts. */
  formatRangeToParts(t, n) {
    if (typeof this.numberFormatter.formatRangeToParts == "function") return this.numberFormatter.formatRangeToParts(t, n);
    if (n < t) throw new RangeError("End date must be >= start date");
    let r = this.numberFormatter.formatToParts(t), o = this.numberFormatter.formatToParts(n);
    return [
      ...r.map((i) => ({
        ...i,
        source: "startRange"
      })),
      {
        type: "literal",
        value: " – ",
        source: "shared"
      },
      ...o.map((i) => ({
        ...i,
        source: "endRange"
      }))
    ];
  }
  /** Returns the resolved formatting options based on the values passed to the constructor. */
  resolvedOptions() {
    let t = this.numberFormatter.resolvedOptions();
    return !ot && this.options.signDisplay != null && (t = {
      ...t,
      signDisplay: this.options.signDisplay
    }), !Re && this.options.style === "unit" && (t = {
      ...t,
      style: "unit",
      unit: this.options.unit,
      unitDisplay: this.options.unitDisplay
    }), t;
  }
  constructor(t, n = {}) {
    this.numberFormatter = Jr(t, n), this.options = n;
  }
}
function Jr(e, t = {}) {
  let { numberingSystem: n } = t;
  if (n && e.includes("-nu-") && (e.includes("-u-") || (e += "-u-"), e += `-nu-${n}`), t.style === "unit" && !Re) {
    var r;
    let { unit: a, unitDisplay: l = "short" } = t;
    if (!a) throw new Error('unit option must be provided with style: "unit"');
    if (!(!((r = En[a]) === null || r === void 0) && r[l])) throw new Error(`Unsupported unit ${a} with unitDisplay = ${l}`);
    t = {
      ...t,
      style: "decimal"
    };
  }
  let o = e + (t ? Object.entries(t).sort((a, l) => a[0] < l[0] ? -1 : 1).join() : "");
  if (Ye.has(o)) return Ye.get(o);
  let i = new Intl.NumberFormat(e, t);
  return Ye.set(o, i), i;
}
function Qr(e, t, n) {
  if (t === "auto") return e.format(n);
  if (t === "never") return e.format(Math.abs(n));
  {
    let r = !1;
    if (t === "always" ? r = n > 0 || Object.is(n, 0) : t === "exceptZero" && (Object.is(n, -0) || Object.is(n, 0) ? n = Math.abs(n) : r = n > 0), r) {
      let o = e.format(-n), i = e.format(n), a = o.replace(i, "").replace(/\u200e|\u061C/, "");
      return [
        ...a
      ].length !== 1 && console.warn("@react-aria/i18n polyfill for NumberFormat signDisplay: Unsupported case"), o.replace(i, "!!!").replace(a, "+").replace("!!!", i);
    } else return e.format(n);
  }
}
function eo(e = {}) {
  let { locale: t } = Pn();
  return te(() => new qr(t, e), [
    t,
    e
  ]);
}
function Tn(e, t) {
  let { elementType: n = "button", isDisabled: r, onPress: o, onPressStart: i, onPressEnd: a, onPressUp: l, onPressChange: u, preventFocusOnPress: d, allowFocusWhenDisabled: f, onClick: p, href: g, target: v, rel: m, type: $ = "button" } = e, y;
  n === "button" ? y = {
    type: $,
    disabled: r
  } : y = {
    role: "button",
    href: n === "a" && !r ? g : void 0,
    target: n === "a" ? v : void 0,
    type: n === "input" ? $ : void 0,
    disabled: n === "input" ? r : void 0,
    "aria-disabled": !r || n === "input" ? void 0 : r,
    rel: n === "a" ? m : void 0
  };
  let { pressProps: h, isPressed: E } = dn({
    onPressStart: i,
    onPressEnd: a,
    onPressChange: u,
    onPress: o,
    onPressUp: l,
    onClick: p,
    isDisabled: r,
    preventFocusOnPress: d,
    ref: t
  }), { focusableProps: L } = Ve(e, t);
  f && (L.tabIndex = r ? -1 : L.tabIndex);
  let O = _(L, h, xe(e, {
    labelable: !0
  }));
  return {
    isPressed: E,
    buttonProps: _(y, O, {
      "aria-haspopup": e["aria-haspopup"],
      "aria-expanded": e["aria-expanded"],
      "aria-controls": e["aria-controls"],
      "aria-pressed": e["aria-pressed"],
      "aria-current": e["aria-current"]
    })
  };
}
function wn(e, t, n) {
  const { isSelected: r } = t, { isPressed: o, buttonProps: i } = Tn({
    ...e,
    onPress: st(t.toggle, e.onPress)
  }, n);
  return {
    isPressed: o,
    isSelected: r,
    isDisabled: e.isDisabled || !1,
    buttonProps: _(i, {
      "aria-pressed": r
    })
  };
}
function mt(e = {}) {
  let { autoFocus: t = !1, isTextInput: n, within: r } = e, o = I({
    isFocused: !1,
    isFocusVisible: t || gt()
  }), [i, a] = G(!1), [l, u] = G(() => o.current.isFocused && o.current.isFocusVisible), d = N(() => u(o.current.isFocused && o.current.isFocusVisible), []), f = N((v) => {
    o.current.isFocused = v, a(v), d();
  }, [
    d
  ]);
  Nr((v) => {
    o.current.isFocusVisible = v, d();
  }, [], {
    isTextInput: n
  });
  let { focusProps: p } = mn({
    isDisabled: r,
    onFocusChange: f
  }), { focusWithinProps: g } = zr({
    isDisabled: !r,
    onFocusWithinChange: f
  });
  return {
    isFocused: i,
    isFocusVisible: l,
    focusProps: r ? g : p
  };
}
function to(e, t, n) {
  let r = {
    isSelected: t.selectedKeys.has(e.id),
    setSelected(u) {
      t.setSelected(e.id, u);
    },
    toggle() {
      t.toggleKey(e.id);
    }
  }, { isPressed: o, isSelected: i, isDisabled: a, buttonProps: l } = wn({
    ...e,
    id: void 0,
    isDisabled: e.isDisabled || t.isDisabled
  }, r, n);
  return t.selectionMode === "single" && (l.role = "radio", l["aria-checked"] = r.isSelected, delete l["aria-pressed"]), {
    isPressed: o,
    isSelected: i,
    isDisabled: a,
    buttonProps: l
  };
}
const xn = 7e3;
let J = null;
function Ht(e, t = "assertive", n = xn) {
  J ? J.announce(e, t, n) : (J = new no(), (typeof IS_REACT_ACT_ENVIRONMENT == "boolean" ? IS_REACT_ACT_ENVIRONMENT : typeof jest < "u") ? J.announce(e, t, n) : setTimeout(() => {
    J?.isAttached() && J?.announce(e, t, n);
  }, 100));
}
class no {
  isAttached() {
    var t;
    return (t = this.node) === null || t === void 0 ? void 0 : t.isConnected;
  }
  createLog(t) {
    let n = document.createElement("div");
    return n.setAttribute("role", "log"), n.setAttribute("aria-live", t), n.setAttribute("aria-relevant", "additions"), n;
  }
  destroy() {
    this.node && (document.body.removeChild(this.node), this.node = null);
  }
  announce(t, n = "assertive", r = xn) {
    var o, i;
    if (!this.node) return;
    let a = document.createElement("div");
    typeof t == "object" ? (a.setAttribute("role", "img"), a.setAttribute("aria-labelledby", t["aria-labelledby"])) : a.textContent = t, n === "assertive" ? (o = this.assertiveLog) === null || o === void 0 || o.appendChild(a) : (i = this.politeLog) === null || i === void 0 || i.appendChild(a), t !== "" && setTimeout(() => {
      a.remove();
    }, r);
  }
  clear(t) {
    this.node && ((!t || t === "assertive") && this.assertiveLog && (this.assertiveLog.innerHTML = ""), (!t || t === "polite") && this.politeLog && (this.politeLog.innerHTML = ""));
  }
  constructor() {
    this.node = null, this.assertiveLog = null, this.politeLog = null, typeof document < "u" && (this.node = document.createElement("div"), this.node.dataset.liveAnnouncer = "true", Object.assign(this.node.style, {
      border: 0,
      clip: "rect(0 0 0 0)",
      clipPath: "inset(50%)",
      height: "1px",
      margin: "-1px",
      overflow: "hidden",
      padding: 0,
      position: "absolute",
      width: "1px",
      whiteSpace: "nowrap"
    }), this.assertiveLog = this.createLog("assertive"), this.node.appendChild(this.assertiveLog), this.politeLog = this.createLog("polite"), this.node.appendChild(this.politeLog), document.body.prepend(this.node));
  }
}
function ro(e) {
  let { id: t, label: n, "aria-labelledby": r, "aria-label": o, labelElementType: i = "label" } = e;
  t = be(t);
  let a = be(), l = {};
  n ? (r = r ? `${a} ${r}` : a, l = {
    id: a,
    htmlFor: i === "label" ? t : void 0
  }) : !r && !o && process.env.NODE_ENV !== "production" && console.warn("If you do not provide a visible label, you must specify an aria-label or aria-labelledby attribute for accessibility");
  let u = cr({
    id: t,
    "aria-label": o,
    "aria-labelledby": r
  });
  return {
    labelProps: l,
    fieldProps: u
  };
}
function oo(e = {}) {
  let { isReadOnly: t } = e, [n, r] = ln(e.isSelected, e.defaultSelected || !1, e.onChange);
  function o(a) {
    t || r(a);
  }
  function i() {
    t || r(!n);
  }
  return {
    isSelected: n,
    setSelected: o,
    toggle: i
  };
}
const Q = {
  top: "top",
  bottom: "top",
  left: "left",
  right: "left"
}, Ke = {
  top: "bottom",
  bottom: "top",
  left: "right",
  right: "left"
}, io = {
  top: "left",
  left: "top"
}, it = {
  top: "height",
  left: "width"
}, Sn = {
  width: "totalWidth",
  height: "totalHeight"
}, De = {};
let R = typeof document < "u" ? window.visualViewport : null;
function At(e) {
  let t = 0, n = 0, r = 0, o = 0, i = 0, a = 0, l = {};
  var u;
  let d = ((u = R?.scale) !== null && u !== void 0 ? u : 1) > 1;
  if (e.tagName === "BODY") {
    let m = document.documentElement;
    r = m.clientWidth, o = m.clientHeight;
    var f;
    t = (f = R?.width) !== null && f !== void 0 ? f : r;
    var p;
    n = (p = R?.height) !== null && p !== void 0 ? p : o, l.top = m.scrollTop || e.scrollTop, l.left = m.scrollLeft || e.scrollLeft, R && (i = R.offsetTop, a = R.offsetLeft);
  } else
    ({ width: t, height: n, top: i, left: a } = pe(e)), l.top = e.scrollTop, l.left = e.scrollLeft, r = t, o = n;
  if (Yt() && (e.tagName === "BODY" || e.tagName === "HTML") && d) {
    l.top = 0, l.left = 0;
    var g;
    i = (g = R?.pageTop) !== null && g !== void 0 ? g : 0;
    var v;
    a = (v = R?.pageLeft) !== null && v !== void 0 ? v : 0;
  }
  return {
    width: t,
    height: n,
    totalWidth: r,
    totalHeight: o,
    scroll: l,
    top: i,
    left: a
  };
}
function lo(e) {
  return {
    top: e.scrollTop,
    left: e.scrollLeft,
    width: e.scrollWidth,
    height: e.scrollHeight
  };
}
function Nt(e, t, n, r, o, i, a) {
  var l;
  let u = (l = o.scroll[e]) !== null && l !== void 0 ? l : 0, d = r[it[e]], f = r.scroll[Q[e]] + i, p = d + r.scroll[Q[e]] - i, g = t - u + a[e] - r[Q[e]], v = t - u + n + a[e] - r[Q[e]];
  return g < f ? f - g : v > p ? Math.max(p - v, f - g) : 0;
}
function ao(e) {
  let t = window.getComputedStyle(e);
  return {
    top: parseInt(t.marginTop, 10) || 0,
    bottom: parseInt(t.marginBottom, 10) || 0,
    left: parseInt(t.marginLeft, 10) || 0,
    right: parseInt(t.marginRight, 10) || 0
  };
}
function Rt(e) {
  if (De[e]) return De[e];
  let [t, n] = e.split(" "), r = Q[t] || "right", o = io[r];
  Q[n] || (n = "center");
  let i = it[r], a = it[o];
  return De[e] = {
    placement: t,
    crossPlacement: n,
    axis: r,
    crossAxis: o,
    size: i,
    crossSize: a
  }, De[e];
}
function Xe(e, t, n, r, o, i, a, l, u, d) {
  let { placement: f, crossPlacement: p, axis: g, crossAxis: v, size: m, crossSize: $ } = r, y = {};
  var h;
  y[v] = (h = e[v]) !== null && h !== void 0 ? h : 0;
  var E, L, O, M;
  p === "center" ? y[v] += (((E = e[$]) !== null && E !== void 0 ? E : 0) - ((L = n[$]) !== null && L !== void 0 ? L : 0)) / 2 : p !== v && (y[v] += ((O = e[$]) !== null && O !== void 0 ? O : 0) - ((M = n[$]) !== null && M !== void 0 ? M : 0)), y[v] += i;
  const S = e[v] - n[$] + u + d, B = e[v] + e[$] - u - d;
  if (y[v] = we(y[v], S, B), f === g) {
    const j = l ? a[m] : t[Sn[m]];
    y[Ke[g]] = Math.floor(j - e[g] + o);
  } else y[g] = Math.floor(e[g] + e[m] + o);
  return y;
}
function so(e, t, n, r, o, i, a, l) {
  const u = r ? n.height : t[Sn.height];
  var d;
  let f = e.top != null ? n.top + e.top : n.top + (u - ((d = e.bottom) !== null && d !== void 0 ? d : 0) - a);
  var p, g, v, m, $, y;
  let h = l !== "top" ? (
    // We want the distance between the top of the overlay to the bottom of the boundary
    Math.max(0, t.height + t.top + ((p = t.scroll.top) !== null && p !== void 0 ? p : 0) - f - (((g = o.top) !== null && g !== void 0 ? g : 0) + ((v = o.bottom) !== null && v !== void 0 ? v : 0) + i))
  ) : Math.max(0, f + a - (t.top + ((m = t.scroll.top) !== null && m !== void 0 ? m : 0)) - ((($ = o.top) !== null && $ !== void 0 ? $ : 0) + ((y = o.bottom) !== null && y !== void 0 ? y : 0) + i));
  return Math.min(t.height - i * 2, h);
}
function Kt(e, t, n, r, o, i) {
  let { placement: a, axis: l, size: u } = i;
  var d, f;
  if (a === l) return Math.max(0, n[l] - e[l] - ((d = e.scroll[l]) !== null && d !== void 0 ? d : 0) + t[l] - ((f = r[l]) !== null && f !== void 0 ? f : 0) - r[Ke[l]] - o);
  var p;
  return Math.max(0, e[u] + e[l] + e.scroll[l] - t[l] - n[l] - n[u] - ((p = r[l]) !== null && p !== void 0 ? p : 0) - r[Ke[l]] - o);
}
function co(e, t, n, r, o, i, a, l, u, d, f, p, g, v, m, $) {
  let y = Rt(e), { size: h, crossAxis: E, crossSize: L, placement: O, crossPlacement: M } = y, S = Xe(t, l, n, y, f, p, d, g, m, $), B = f, j = Kt(l, d, t, o, i + f, y);
  if (a && r[h] > j) {
    let Be = Rt(`${Ke[O]} ${M}`), In = Xe(t, l, n, Be, f, p, d, g, m, $);
    Kt(l, d, t, o, i + f, Be) > j && (y = Be, S = In, B = f);
  }
  let U = "bottom";
  y.axis === "top" ? y.placement === "top" ? U = "top" : y.placement === "bottom" && (U = "bottom") : y.crossAxis === "top" && (y.crossPlacement === "top" ? U = "bottom" : y.crossPlacement === "bottom" && (U = "top"));
  let H = Nt(E, S[E], n[L], l, u, i, d);
  S[E] += H;
  let s = so(S, l, d, g, o, i, n.height, U);
  v && v < s && (s = v), n.height = Math.min(n.height, s), S = Xe(t, l, n, y, B, p, d, g, m, $), H = Nt(E, S[E], n[L], l, u, i, d), S[E] += H;
  let P = {}, F = t[E] + 0.5 * t[L] - S[E] - o[Q[E]];
  const b = m / 2 + $;
  var C, c, T, w;
  const V = Q[E] === "left" ? ((C = o.left) !== null && C !== void 0 ? C : 0) + ((c = o.right) !== null && c !== void 0 ? c : 0) : ((T = o.top) !== null && T !== void 0 ? T : 0) + ((w = o.bottom) !== null && w !== void 0 ? w : 0), ze = n[L] - V - m / 2 - $, On = t[E] + m / 2 - (S[E] + o[Q[E]]), Mn = t[E] + t[L] - m / 2 - (S[E] + o[Q[E]]), Dn = we(F, On, Mn);
  return P[E] = we(Dn, b, ze), {
    position: S,
    maxHeight: s,
    arrowOffsetLeft: P.left,
    arrowOffsetTop: P.top,
    placement: y.placement
  };
}
function uo(e) {
  let { placement: t, targetNode: n, overlayNode: r, scrollNode: o, padding: i, shouldFlip: a, boundaryElement: l, offset: u, crossOffset: d, maxHeight: f, arrowSize: p = 0, arrowBoundaryOffset: g = 0 } = e, v = r instanceof HTMLElement ? fo(r) : document.documentElement, m = v === document.documentElement;
  const $ = window.getComputedStyle(v).position;
  let y = !!$ && $ !== "static", h = m ? pe(n) : _t(n, v);
  if (!m) {
    let { marginTop: P, marginLeft: F } = window.getComputedStyle(n);
    h.top += parseInt(P, 10) || 0, h.left += parseInt(F, 10) || 0;
  }
  let E = pe(r), L = ao(r);
  var O, M;
  E.width += ((O = L.left) !== null && O !== void 0 ? O : 0) + ((M = L.right) !== null && M !== void 0 ? M : 0);
  var S, B;
  E.height += ((S = L.top) !== null && S !== void 0 ? S : 0) + ((B = L.bottom) !== null && B !== void 0 ? B : 0);
  let j = lo(o), U = At(l), H = At(v), s = l.tagName === "BODY" ? pe(v) : _t(v, l);
  return v.tagName === "HTML" && l.tagName === "BODY" && (H.scroll.top = 0, H.scroll.left = 0), co(t, h, E, j, L, i, a, U, H, s, u, d, y, f, p, g);
}
function pe(e) {
  let { top: t, left: n, width: r, height: o } = e.getBoundingClientRect(), { scrollTop: i, scrollLeft: a, clientTop: l, clientLeft: u } = document.documentElement;
  return {
    top: t + i - l,
    left: n + a - u,
    width: r,
    height: o
  };
}
function _t(e, t) {
  let n = window.getComputedStyle(e), r;
  if (n.position === "fixed") {
    let { top: o, left: i, width: a, height: l } = e.getBoundingClientRect();
    r = {
      top: o,
      left: i,
      width: a,
      height: l
    };
  } else {
    r = pe(e);
    let o = pe(t), i = window.getComputedStyle(t);
    o.top += (parseInt(i.borderTopWidth, 10) || 0) - t.scrollTop, o.left += (parseInt(i.borderLeftWidth, 10) || 0) - t.scrollLeft, r.top -= o.top, r.left -= o.left;
  }
  return r.top -= parseInt(n.marginTop, 10) || 0, r.left -= parseInt(n.marginLeft, 10) || 0, r;
}
function fo(e) {
  let t = e.offsetParent;
  if (t && t === document.body && window.getComputedStyle(t).position === "static" && !Vt(t) && (t = document.documentElement), t == null)
    for (t = e.parentElement; t && !Vt(t); ) t = t.parentElement;
  return t || document.documentElement;
}
function Vt(e) {
  let t = window.getComputedStyle(e);
  return t.transform !== "none" || /transform|perspective/.test(t.willChange) || t.filter !== "none" || t.contain === "paint" || "backdropFilter" in t && t.backdropFilter !== "none" || "WebkitBackdropFilter" in t && t.WebkitBackdropFilter !== "none";
}
const po = /* @__PURE__ */ new WeakMap();
function bo(e) {
  let { triggerRef: t, isOpen: n, onClose: r } = e;
  K(() => {
    if (!n || r === null) return;
    let o = (i) => {
      let a = i.target;
      if (!t.current || a instanceof Node && !a.contains(t.current) || i.target instanceof HTMLInputElement || i.target instanceof HTMLTextAreaElement) return;
      let l = r || po.get(t.current);
      l && l();
    };
    return window.addEventListener("scroll", o, !0), () => {
      window.removeEventListener("scroll", o, !0);
    };
  }, [
    n,
    r,
    t
  ]);
}
let A = typeof document < "u" ? window.visualViewport : null;
function vo(e) {
  let { direction: t } = Pn(), { arrowSize: n = 0, targetRef: r, overlayRef: o, scrollRef: i = o, placement: a = "bottom", containerPadding: l = 12, shouldFlip: u = !0, boundaryElement: d = typeof document < "u" ? document.body : null, offset: f = 0, crossOffset: p = 0, shouldUpdatePosition: g = !0, isOpen: v = !0, onClose: m, maxHeight: $, arrowBoundaryOffset: y = 0 } = e, [h, E] = G(null), L = [
    g,
    a,
    o.current,
    r.current,
    i.current,
    l,
    u,
    d,
    f,
    p,
    v,
    t,
    $,
    y,
    n
  ], O = I(A?.scale);
  K(() => {
    v && (O.current = A?.scale);
  }, [
    v
  ]);
  let M = N(() => {
    if (g === !1 || !v || !o.current || !r.current || !d || A?.scale !== O.current) return;
    let H = null;
    if (i.current && i.current.contains(document.activeElement)) {
      var s;
      let w = (s = document.activeElement) === null || s === void 0 ? void 0 : s.getBoundingClientRect(), V = i.current.getBoundingClientRect();
      var P;
      if (H = {
        type: "top",
        offset: ((P = w?.top) !== null && P !== void 0 ? P : 0) - V.top
      }, H.offset > V.height / 2) {
        H.type = "bottom";
        var F;
        H.offset = ((F = w?.bottom) !== null && F !== void 0 ? F : 0) - V.bottom;
      }
    }
    let b = o.current;
    if (!$ && o.current) {
      var C;
      b.style.top = "0px", b.style.bottom = "";
      var c;
      b.style.maxHeight = ((c = (C = window.visualViewport) === null || C === void 0 ? void 0 : C.height) !== null && c !== void 0 ? c : window.innerHeight) + "px";
    }
    let T = uo({
      placement: go(a, t),
      overlayNode: o.current,
      targetNode: r.current,
      scrollNode: i.current || o.current,
      padding: l,
      shouldFlip: u,
      boundaryElement: d,
      offset: f,
      crossOffset: p,
      maxHeight: $,
      arrowSize: n,
      arrowBoundaryOffset: y
    });
    if (T.position) {
      if (b.style.top = "", b.style.bottom = "", b.style.left = "", b.style.right = "", Object.keys(T.position).forEach((w) => b.style[w] = T.position[w] + "px"), b.style.maxHeight = T.maxHeight != null ? T.maxHeight + "px" : "", H && document.activeElement && i.current) {
        let w = document.activeElement.getBoundingClientRect(), V = i.current.getBoundingClientRect(), ze = w[H.type] - V[H.type];
        i.current.scrollTop += ze - H.offset;
      }
      E(T);
    }
  }, L);
  q(M, L), $o(M), Et({
    ref: o,
    onResize: M
  }), Et({
    ref: r,
    onResize: M
  });
  let S = I(!1);
  q(() => {
    let H, s = () => {
      S.current = !0, clearTimeout(H), H = setTimeout(() => {
        S.current = !1;
      }, 500), M();
    }, P = () => {
      S.current && s();
    };
    return A?.addEventListener("resize", s), A?.addEventListener("scroll", P), () => {
      A?.removeEventListener("resize", s), A?.removeEventListener("scroll", P);
    };
  }, [
    M
  ]);
  let B = N(() => {
    S.current || m?.();
  }, [
    m,
    S
  ]);
  bo({
    triggerRef: r,
    isOpen: v,
    onClose: m && B
  });
  var j, U;
  return {
    overlayProps: {
      style: {
        position: "absolute",
        zIndex: 1e5,
        ...h?.position,
        maxHeight: (j = h?.maxHeight) !== null && j !== void 0 ? j : "100vh"
      }
    },
    placement: (U = h?.placement) !== null && U !== void 0 ? U : null,
    arrowProps: {
      "aria-hidden": "true",
      role: "presentation",
      style: {
        left: h?.arrowOffsetLeft,
        top: h?.arrowOffsetTop
      }
    },
    updatePosition: M
  };
}
function $o(e) {
  q(() => (window.addEventListener("resize", e, !1), () => {
    window.removeEventListener("resize", e, !1);
  }), [
    e
  ]);
}
function go(e, t) {
  return t === "rtl" ? e.replace("start", "right").replace("end", "left") : e.replace("start", "left").replace("end", "right");
}
const mo = /* @__PURE__ */ Z({});
function ho() {
  var e;
  return (e = W(mo)) !== null && e !== void 0 ? e : {};
}
const lt = /* @__PURE__ */ x.createContext(null);
function yo(e) {
  let { children: t } = e, n = W(lt), [r, o] = G(0), i = te(() => ({
    parent: n,
    modalCount: r,
    addModal() {
      o((a) => a + 1), n && n.addModal();
    },
    removeModal() {
      o((a) => a - 1), n && n.removeModal();
    }
  }), [
    n,
    r
  ]);
  return /* @__PURE__ */ x.createElement(lt.Provider, {
    value: i
  }, t);
}
function Po() {
  let e = W(lt);
  return {
    modalProviderProps: {
      "aria-hidden": e && e.modalCount > 0 ? !0 : void 0
    }
  };
}
function Eo(e) {
  let { modalProviderProps: t } = Po();
  return /* @__PURE__ */ x.createElement("div", {
    "data-overlay-container": !0,
    ...e,
    ...t
  });
}
function To(e) {
  return /* @__PURE__ */ x.createElement(yo, null, /* @__PURE__ */ x.createElement(Eo, e));
}
function wo(e) {
  let t = at(), { portalContainer: n = t ? null : document.body, ...r } = e, { getContainer: o } = ho();
  if (!e.portalContainer && o && (n = o()), x.useEffect(() => {
    if (n?.closest("[data-overlay-container]")) throw new Error("An OverlayContainer must not be inside another container. Please change the portalContainer prop.");
  }, [
    n
  ]), !n) return null;
  let i = /* @__PURE__ */ x.createElement(To, r);
  return /* @__PURE__ */ kn.createPortal(i, n);
}
function xo(e) {
  let { value: t = 0, minValue: n = 0, maxValue: r = 100, valueLabel: o, isIndeterminate: i, formatOptions: a = {
    style: "percent"
  } } = e, l = xe(e, {
    labelable: !0
  }), { labelProps: u, fieldProps: d } = ro({
    ...e,
    // Progress bar is not an HTML input element so it
    // shouldn't be labeled by a <label> element.
    labelElementType: "span"
  });
  t = we(t, n, r);
  let f = (t - n) / (r - n), p = eo(a);
  if (!i && !o) {
    let g = a.style === "percent" ? f : t;
    o = p.format(g);
  }
  return {
    progressBarProps: _(l, {
      ...d,
      "aria-valuenow": i ? void 0 : t,
      "aria-valuemin": n,
      "aria-valuemax": r,
      "aria-valuetext": i ? void 0 : o,
      role: "progressbar"
    }),
    labelProps: u
  };
}
function So(e, t) {
  let n = xe(e, {
    labelable: !0
  }), { hoverProps: r } = Ce({
    onHoverStart: () => t?.open(!0),
    onHoverEnd: () => t?.close()
  });
  return {
    tooltipProps: _(n, r, {
      role: "tooltip"
    })
  };
}
function Lo(e, t, n) {
  let { isDisabled: r, trigger: o } = e, i = be(), a = I(!1), l = I(!1), u = () => {
    (a.current || l.current) && t.open(l.current);
  }, d = (h) => {
    !a.current && !l.current && t.close(h);
  };
  K(() => {
    let h = (E) => {
      n && n.current && E.key === "Escape" && (E.stopPropagation(), t.close(!0));
    };
    if (t.isOpen)
      return document.addEventListener("keydown", h, !0), () => {
        document.removeEventListener("keydown", h, !0);
      };
  }, [
    n,
    t
  ]);
  let f = () => {
    o !== "focus" && (gn() === "pointer" ? a.current = !0 : a.current = !1, u());
  }, p = () => {
    o !== "focus" && (l.current = !1, a.current = !1, d());
  }, g = () => {
    l.current = !1, a.current = !1, d(!0);
  }, v = () => {
    gt() && (l.current = !0, u());
  }, m = () => {
    l.current = !1, a.current = !1, d(!0);
  }, { hoverProps: $ } = Ce({
    isDisabled: r,
    onHoverStart: f,
    onHoverEnd: p
  }), { focusableProps: y } = Ve({
    isDisabled: r,
    onFocus: v,
    onBlur: m
  }, n);
  return {
    triggerProps: {
      "aria-describedby": t.isOpen ? i : void 0,
      ..._(y, $, {
        onPointerDown: g,
        onKeyDown: g,
        tabIndex: void 0
      })
    },
    tooltipProps: {
      id: i
    }
  };
}
const Co = /* @__PURE__ */ Z({}), Ln = /* @__PURE__ */ Z(null), Wo = /* @__PURE__ */ ge(function(t, n) {
  [t, n] = Le(t, n, Ln);
  let { value: r = 0, minValue: o = 0, maxValue: i = 100, isIndeterminate: a = !1 } = t;
  r = we(r, o, i);
  let [l, u] = mr(!t["aria-label"] && !t["aria-labelledby"]), { progressBarProps: d, labelProps: f } = xo({
    ...t,
    label: u
  }), p = a ? void 0 : (r - o) / (i - o) * 100, g = Se({
    ...t,
    defaultClassName: "react-aria-ProgressBar",
    values: {
      percentage: p,
      valueText: d["aria-valuetext"],
      isIndeterminate: a
    }
  });
  return /* @__PURE__ */ x.createElement("div", {
    ...d,
    ...g,
    ref: n,
    slot: t.slot || void 0
  }, /* @__PURE__ */ x.createElement(Co.Provider, {
    value: {
      ...f,
      ref: l,
      elementType: "span"
    }
  }, g.children));
}), Fo = /* @__PURE__ */ new Set([
  "form",
  "formAction",
  "formEncType",
  "formMethod",
  "formNoValidate",
  "formTarget",
  "name",
  "value"
]), Oo = /* @__PURE__ */ Z({}), jo = /* @__PURE__ */ yr(function(t, n) {
  [t, n] = Le(t, n, Oo), t = Mo(t);
  let r = t, { isPending: o } = r, { buttonProps: i, isPressed: a } = Tn(t, n), { focusProps: l, isFocused: u, isFocusVisible: d } = mt(t), { hoverProps: f, isHovered: p } = Ce({
    ...t,
    isDisabled: t.isDisabled || o
  }), g = {
    isHovered: p,
    isPressed: (r.isPressed || a) && !o,
    isFocused: u,
    isFocusVisible: d,
    isDisabled: t.isDisabled || !1,
    isPending: o ?? !1
  }, v = Se({
    ...t,
    values: g,
    defaultClassName: "react-aria-Button"
  }), m = be(i.id), $ = be(), y = i["aria-labelledby"];
  o && (y ? y = `${y} ${$}` : i["aria-label"] && (y = `${m} ${$}`));
  let h = I(o);
  return K(() => {
    let E = {
      "aria-labelledby": y || m
    };
    (!h.current && u && o || h.current && u && !o) && Ht(E, "assertive"), h.current = o;
  }, [
    o,
    u,
    y,
    m
  ]), /* @__PURE__ */ x.createElement("button", {
    ...xe(t, {
      propNames: Fo
    }),
    ..._(i, l, f),
    ...v,
    type: i.type === "submit" && o ? "button" : i.type,
    id: m,
    ref: n,
    "aria-labelledby": y,
    slot: t.slot || void 0,
    "aria-disabled": o ? "true" : i["aria-disabled"],
    "data-disabled": t.isDisabled || void 0,
    "data-pressed": g.isPressed || void 0,
    "data-hovered": p || void 0,
    "data-focused": u || void 0,
    "data-pending": o || void 0,
    "data-focus-visible": d || void 0
  }, /* @__PURE__ */ x.createElement(Ln.Provider, {
    value: {
      id: $
    }
  }, v.children));
});
function Mo(e) {
  return e.isPending && (e.onPress = void 0, e.onPressStart = void 0, e.onPressEnd = void 0, e.onPressChange = void 0, e.onPressUp = void 0, e.onKeyDown = void 0, e.onKeyUp = void 0, e.onClick = void 0, e.href = void 0), e;
}
function Do(e) {
  let [t, n] = ln(e.isOpen, e.defaultOpen || !1, e.onOpenChange);
  const r = N(() => {
    n(!0);
  }, [
    n
  ]), o = N(() => {
    n(!1);
  }, [
    n
  ]), i = N(() => {
    n(!t);
  }, [
    n,
    t
  ]);
  return {
    isOpen: t,
    setOpen: n,
    open: r,
    close: o,
    toggle: i
  };
}
const Io = 1500, zt = 500;
let ae = {}, ko = 0, he = !1, ee = null, se = null;
function Cn(e = {}) {
  let { delay: t = Io, closeDelay: n = zt } = e, { isOpen: r, open: o, close: i } = Do(e), a = te(() => `${++ko}`, []), l = I(null), u = I(i), d = () => {
    ae[a] = g;
  }, f = () => {
    for (let m in ae) m !== a && (ae[m](!0), delete ae[m]);
  }, p = () => {
    l.current && clearTimeout(l.current), l.current = null, f(), d(), he = !0, o(), ee && (clearTimeout(ee), ee = null), se && (clearTimeout(se), se = null);
  }, g = (m) => {
    m || n <= 0 ? (l.current && clearTimeout(l.current), l.current = null, u.current()) : l.current || (l.current = setTimeout(() => {
      l.current = null, u.current();
    }, n)), ee && (clearTimeout(ee), ee = null), he && (se && clearTimeout(se), se = setTimeout(() => {
      delete ae[a], se = null, he = !1;
    }, Math.max(zt, n)));
  }, v = () => {
    f(), d(), !r && !ee && !he ? ee = setTimeout(() => {
      ee = null, he = !0, p();
    }, t) : r || p();
  };
  return K(() => {
    u.current = i;
  }, [
    i
  ]), K(() => () => {
    l.current && clearTimeout(l.current), ae[a] && delete ae[a];
  }, [
    a
  ]), {
    isOpen: r,
    open: (m) => {
      !m && t > 0 && !l.current ? v() : p();
    },
    close: g
  };
}
const Ho = /* @__PURE__ */ Z(null), Go = /* @__PURE__ */ ge(function(t, n) {
  [t, n] = Le(t, n, Ho);
  let r = t.href && !t.isDisabled ? "a" : "span", { linkProps: o, isPressed: i } = Ur({
    ...t,
    elementType: r
  }, n), { hoverProps: a, isHovered: l } = Ce(t), { focusProps: u, isFocused: d, isFocusVisible: f } = mt(), p = Se({
    ...t,
    defaultClassName: "react-aria-Link",
    values: {
      isCurrent: !!t["aria-current"],
      isDisabled: t.isDisabled || !1,
      isPressed: i,
      isHovered: l,
      isFocused: d,
      isFocusVisible: f
    }
  });
  return /* @__PURE__ */ x.createElement(r, {
    ref: n,
    slot: t.slot || void 0,
    ..._(p, o, a, u),
    "data-focused": d || void 0,
    "data-hovered": l || void 0,
    "data-pressed": i || void 0,
    "data-focus-visible": f || void 0,
    "data-current": !!t["aria-current"] || void 0,
    "data-disabled": t.isDisabled || void 0
  }, p.children);
}), Ao = /* @__PURE__ */ Z({
  placement: "bottom"
}), No = /* @__PURE__ */ Z(null), Ro = /* @__PURE__ */ Z({}), Yo = /* @__PURE__ */ ge(function(t, n) {
  [t, n] = Le(t, n, Ro);
  let r = W(No), o = oo(r && t.id != null ? {
    isSelected: r.selectedKeys.has(t.id),
    onChange($) {
      r.setSelected(t.id, $);
    }
  } : t), { buttonProps: i, isPressed: a, isSelected: l, isDisabled: u } = r && t.id != null ? to({
    ...t,
    id: t.id
  }, r, n) : wn({
    ...t,
    id: t.id != null ? String(t.id) : void 0
  }, o, n), { focusProps: d, isFocused: f, isFocusVisible: p } = mt(t), { hoverProps: g, isHovered: v } = Ce(t), m = Se({
    ...t,
    id: void 0,
    values: {
      isHovered: v,
      isPressed: a,
      isFocused: f,
      isSelected: o.isSelected,
      isFocusVisible: p,
      isDisabled: u,
      state: o
    },
    defaultClassName: "react-aria-ToggleButton"
  });
  return /* @__PURE__ */ x.createElement("button", {
    ..._(i, d, g),
    ...m,
    ref: n,
    slot: t.slot || void 0,
    "data-focused": f || void 0,
    "data-disabled": u || void 0,
    "data-pressed": a || void 0,
    "data-selected": l || void 0,
    "data-hovered": v || void 0,
    "data-focus-visible": p || void 0
  });
}), ht = /* @__PURE__ */ Z(null), Fn = /* @__PURE__ */ Z(null);
function Xo(e) {
  let t = Cn(e), n = I(null), { triggerProps: r, tooltipProps: o } = Lo(e, t, n);
  return /* @__PURE__ */ x.createElement($r, {
    values: [
      [
        ht,
        t
      ],
      [
        Fn,
        {
          ...o,
          triggerRef: n
        }
      ]
    ]
  }, /* @__PURE__ */ x.createElement(Vr, {
    ...r,
    ref: n
  }, e.children));
}
const Zo = /* @__PURE__ */ ge(function({ UNSTABLE_portalContainer: t, ...n }, r) {
  [n, r] = Le(n, r, Fn);
  let o = W(ht), i = Cn(n), a = n.isOpen != null || n.defaultOpen != null || !o ? i : o, l = pr(r, a.isOpen) || n.isExiting || !1;
  return !a.isOpen && !l ? null : /* @__PURE__ */ x.createElement(wo, {
    portalContainer: t
  }, /* @__PURE__ */ x.createElement(Ko, {
    ...n,
    tooltipRef: r,
    isExiting: l
  }));
});
function Ko(e) {
  let t = W(ht), n = I(null), [r, o] = G(0);
  q(() => {
    n.current && t.isOpen && o(n.current.getBoundingClientRect().width);
  }, [
    t.isOpen,
    n
  ]);
  let { overlayProps: i, arrowProps: a, placement: l } = vo({
    placement: e.placement || "top",
    targetRef: e.triggerRef,
    overlayRef: e.tooltipRef,
    offset: e.offset,
    crossOffset: e.crossOffset,
    isOpen: t.isOpen,
    arrowSize: r,
    arrowBoundaryOffset: e.arrowBoundaryOffset,
    shouldFlip: e.shouldFlip,
    onClose: () => t.close(!0)
  }), u = fr(e.tooltipRef, !!l) || e.isEntering || !1, d = Se({
    ...e,
    defaultClassName: "react-aria-Tooltip",
    values: {
      placement: l,
      isEntering: u,
      isExiting: e.isExiting,
      state: t
    }
  });
  e = _(e, i);
  let { tooltipProps: f } = So(e, t);
  return /* @__PURE__ */ x.createElement("div", {
    ...f,
    ref: e.tooltipRef,
    ...d,
    style: {
      ...i.style,
      ...d.style
    },
    "data-placement": l ?? void 0,
    "data-entering": u || void 0,
    "data-exiting": e.isExiting || void 0
  }, /* @__PURE__ */ x.createElement(Ao.Provider, {
    value: {
      ...a,
      placement: l,
      ref: n
    }
  }, d.children));
}
export {
  Yo as $,
  Go as a,
  Bo as b,
  Hn as c,
  jo as d,
  Wo as e,
  Xo as f,
  Zo as g,
  mt as h,
  Ce as i,
  be as j,
  Uo as k
};
//# sourceMappingURL=vendor-DgBgaXRO.js.map
